<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            <CRow class="align-items-center my-1">
                <div class="col-12">
                    <p style="font-weight: bold; font-size: 16px; background: -webkit-linear-gradient(186deg, rgb(255, 167, 0) 40%, rgb(255, 123, 0) 100%) text; -webkit-text-fill-color: transparent; margin-bottom: 0;">
                        {{this.getLanguage['SMB']['M']}}
                    </p>
                </div>
                <div class="col-12 d-flex ">
                    <div class="quicklink position-relative">
                        <a href="javascript:void(0)" :class="isShowDetails ? 'active' : ''" @click="isShowQR = false;isShowPL =false;isShowForm=false;isShowDetails=true;getMemberList()">
                            {{getLanguage['GL']['D']}} <sup v-if="arr_MemberList.length > 0">{{arr_MemberList.length}}</sup>
                        </a>
                        <a href="javascript:void(0)" :class="isShowPL ? 'active' : ''" @click="isShowQR = false;isShowPL =true;isShowForm=false;isShowDetails=false;getMemberProfitLossList()">
                            {{getLanguage['SMB']['RS3']}} <sup v-if="arr_profitLossList.length > 0">{{arr_profitLossList.length}}</sup>
                        </a>
                        <a href="javascript:void(0)" :class="isShowForm ? 'active' : ''" @click="isShowQR = false;isShowPL =false;isShowForm=true;isShowDetails=false;">
                            + {{getLanguage['DB']['M']}}
                        </a>
                        <a href="javascript:void(0)" :class="isShowQR ? 'active' : ''" @click="isShowQR = true;isShowPL =false;isShowForm=false;isShowDetails=false;generateQRCode()">
                            + {{this.getLanguage['BAL']['QRUR']}}
                        </a>
                        <img class="img-fluid float-right" v-if="isShowDetails" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_earth-19.svg" width="20" style="position: absolute; right: 0; top: 50%; transform: translate(0%, -50%); " @click="slideinSearchFilter ? slideinSearchFilter = false:slideinSearchFilter = true">
                        <img class="img-fluid float-right" v-if="isShowPL" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_earth-19.svg" width="20" style="position: absolute; right: 0; top: 50%; transform: translate(0%, -50%); " @click="slideinPLSearchfilter ? slideinPLSearchfilter = false:slideinPLSearchfilter = true">
                    </div>
                </div>
            </CRow>

            <template v-if="isShowDetails">
                <CRow>
                    <CCol col="12">
                        <div class="record-header">
                            <div class="" @click="setSortTable('U')">
                                {{getLanguage['MEM']['ACC']}} / {{getLanguage['MEM']['LLT']}} <!--{{getLanguage['AG']['PC']}}--> <!--{{getLanguage['MEM']['LLT']}}-->
                                <i :class="setSortLogo('U')" class="sortlogo"></i>
                            </div>
                            <div class="text-right" @click="setSortTable('CBL')">
                                {{getLanguage['MEM']['CBL']}}
                                <i :class="setSortLogo('CBL')" class="sortlogo"></i>
                            </div>
                        </div>
                        <div class="nodata-record" v-if="arr_MemberList.length == 0">
                            <div>
                                <img class="img-fluid" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_norecord.svg" width="125">
                                <span class="d-block" style="margin-top: -17px;"> {{this.getLanguage['GL']['NR']}}</span>
                            </div>
                        </div>
                        <div class="record-item" v-for="(data,index) in arr_MemberList" @click="slideInMemberDetail(data)">
                            <div>
                                <div class="font-weight-bold text-white" :class="data.RS == 1? 'blacklist-member': data.RS == 3? 'freeze-member': ''">{{data.U}}</div>
                                <div class="record-desc">
                                    <!--<span class="saggroupname">{{ data.SAGN }}</span>-->

                                    <template v-if="data.LLTS">
                                        {{data.LLTS | moment('DD MMM YYYY HH:mm:ss')}}
                                    </template>
                                    <template v-else>
                                        {{getLanguage['MEM']['NRLLT']}}
                                    </template>
                                </div>
                            </div>

                            <div class="text-right">
                                <div class="">{{ formatNumber(data.CBL, 2, data.CS) }}</div>
                            </div>
                        </div>
                    </CCol>
                </CRow>
            </template>
            <template v-if="isShowPL">
                <CRow>
                    <CCol col="12">
                        <div class="record-header" style=" grid-template-columns: auto 100px 100px ">
                            <div class="" @click="setSortTable2('U')">
                                {{getLanguage['MEM']['U']}} / {{getLanguage['AG']['PC']}}
                                <i :class="setSortLogo2('U')" class="sortlogo"></i>
                            </div>
                            <div class="text-right" @click="setSortTable2('TA')">
                                {{getLanguage['BETRPT']['TRO']}}
                                <i :class="setSortLogo2('TA')" class="sortlogo"></i>
                            </div>
                            <div class="text-right" @click="setSortTable2('WLA')">
                                {{getLanguage['PM']['GWL']}}
                                <i :class="setSortLogo2('WLA')" class="sortlogo"></i>
                            </div>
                        </div>
                        <div class="nodata-record" v-if="arr_profitLossList.length == 0">
                            <div>
                                <img class="img-fluid" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_norecord.svg" width="125">
                                <span class="d-block" style="margin-top: -17px;"> {{this.getLanguage['GL']['NR']}}</span>
                            </div>
                        </div>
                        <div class="record-item" v-for="(data,index) in arr_profitLossList" :class="data.MS == 1? 'blacklist-row': ''" style="grid-template-columns: auto 100px 100px ">
                            <div class="text-white">
                                {{data.U}}
                                <div class="record-desc">
                                    <span class="saggroupname">{{ data.SAGGN }}</span>
                                </div>
                            </div>
                            <div class="text-right">
                                <span class="font-weight-bold" :style="changeNegativecolor(data.TA)">{{ formatNumber(data.TA, 2, data.CS) }}</span>
                            </div>
                            <div class="text-right">
                                <span class="font-weight-bold" :style="changeNegativecolor(data.WLA) ">{{ formatNumber(data.WLA, 2, data.CS) }}</span>
                            </div>
                        </div>
                        <div class="record-item" v-if="arr_mainProfitLossList!=null && arr_profitLossList.length > 0" style="color: rgb(255, 255, 255); height: 55px; position: relative; gap: 5px; display: grid; grid-template-columns: auto 100px 100px;">
                            <div class="font-weight-bold" style="color:#fba506">{{this.getLanguage['DCSR']['T']}}</div>
                            <div class="text-right">
                                <span class="font-weight-bold" :style="changeNegativecolor(arr_mainProfitLossList.TA)">{{ formatNumber(arr_mainProfitLossList.TA, 2, arr_mainProfitLossList.CS) }}</span>
                            </div>
                            <div class="text-right">
                                <span class="font-weight-bold" :style="changeNegativecolor(arr_mainProfitLossList.WLA)">{{ formatNumber(arr_mainProfitLossList.WLA, 2, arr_mainProfitLossList.CS) }}</span>
                            </div>
                        </div>
                    </CCol>
                </CRow>
            </template>
            <template v-if="isShowForm">
                <form>
                    <div class="inputform" style="">
                        <div class="form-section mt-0">
                            <div class="sliding-item">
                                <div class="sliding-item-title">{{this.getLanguage["MEM"]["U"]}} <span class="required" /></div>
                                <div class="sliding-item-desc">
                                    <CInput type="text" size="sm" :disabled="obj_member2.I > 0" vertical :placeholder="this.getLanguage['MEM']['U']" :value="obj_member2.U" @change="v => obj_member2.U = v" ref="U" autocomplete="username"></CInput>
                                    <span class="ErrMsg">{{ ValidationMemberErrMsg2('U') }}</span>
                                </div>
                            </div>
                            <div class="sliding-item">
                                <div class="sliding-item-title">{{this.getLanguage["MEM"]["UP"]}} <span class="required" /></div>
                                <div class="sliding-item-desc">
                                    <CInput :type="isShowPassword ? 'text' : 'password'" size="sm" :placeholder="getLanguage['MEM']['UP']" v-model="obj_member2.UP" autocomplete="new-password">
                                        <template #append>
                                            <CButton size="sm"
                                                     type="button"
                                                     color="primary"
                                                     @click="isShowPassword = !isShowPassword"
                                                     style=" min-width: 40px; z-index: 0; background: #25282d !important; border: none !important;">
                                                <i class="fa fa-eye" v-if="isShowPassword"></i>
                                                <i class="fa fa-eye-slash" v-else></i>
                                            </CButton>
                                        </template>
                                    </CInput>
                                    <span class="ErrMsg">{{ ValidationMemberErrMsg2('UP') }}</span>
                                </div>
                            </div>
                            <div class="sliding-item">
                                <div class="sliding-item-title">{{this.getLanguage["MEM"]["CUP"]}} <span class="required" /></div>
                                <div class="sliding-item-desc">
                                    <CInput :type="isShowConfirmPassword ? 'text' : 'password'" size="sm" :placeholder="getLanguage['MEM']['CUP']" v-model="obj_member2.CUP" autocomplete="confirm-password">
                                        <template #append>
                                            <CButton size="sm"
                                                     type="button"
                                                     color="primary"
                                                     @click="isShowConfirmPassword = !isShowConfirmPassword"
                                                     style=" min-width: 40px; z-index: 0; background: #25282d !important; border: none !important;">
                                                <i class="fa fa-eye" v-if="isShowConfirmPassword"></i>
                                                <i class="fa fa-eye-slash" v-else></i>
                                            </CButton>
                                        </template>
                                    </CInput>
                                    <span class="ErrMsg">{{ ValidationMemberErrMsg2('CUP') }}</span>
                                </div>
                            </div>
                            <div class="sliding-item">
                                <div class="sliding-item-title">{{this.getLanguage['MEM']['CI']}}<span class="required" /></div>
                                <div class="sliding-item-desc">
                                    <treeselect :multiple="false"
                                                :load-options="loadEditMemberCurrencyOptions2"
                                                :options="ddEditMemberCurrencyList2"
                                                :auto-load-root-options="false"
                                                :disable-branch-nodes="true"
                                                :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                                v-model="obj_member2.CI"
                                                ref="CI" />
                                    <span class="ErrMsg">{{ ValidationMemberErrMsg2('CI') }}</span>
                                </div>
                            </div>
                            <div class="sliding-item">
                                <div class="sliding-item-title">{{this.getLanguage["MEM"]["E"]}}</div>
                                <div class="sliding-item-desc">
                                    <CInput type="email" size="sm" vertical :placeholder="this.getLanguage['MEM']['E']" v-model="obj_member2.E"></CInput>
                                    <span class="ErrMsg">{{ ValidationMemberErrMsg2('E') }}</span>
                                </div>
                            </div>
                            <div class="sliding-item">
                                <div class="sliding-item-title">{{this.getLanguage["MEM"]["PN"]}}</div>
                                <div class="sliding-item-desc">
                                    <CInput type="text" size="sm" vertical :placeholder="this.getLanguage['MEM']['PN']" v-model="obj_member2.PN"></CInput>
                                </div>
                            </div>

                            <CButton block color="success" class='font-weight-bold m-0 mb-5' @shortkey="saveMember2()" @click="saveMember2()"><span>{{this.getLanguage['BTN']['SV']}}</span></CButton>
                        </div>
                    </div>
                </form>
            </template>
            <template v-if="isShowQR">
                <div class="text-white text-center py-3" v-if="recuitQRCode">
                    <div class="qrcodecard" id="capture-area">
                        <div class="center spacer">
                            <h2>
                                {{getLanguage['S']['QRIMGT1']}}<br>{{getLanguage['S']['QRIMGT2']}}
                            </h2>

                            <div class="position-relative text-center">
                                <img :src="'data:image/png;base64,' + recuitQRCode" class="img-fluid qrcode" alt="QR Code" width="180" height="180"/>
                                <img src="https://media.afb.gg/BackOfficeSiteIco/ggearn-ico.png" class="img-fluid qrcode-logo"  />
                            </div>

                            <div class="position-relative text-center text-white py-2" style="line-height: 35px;">
                                <p class="mb-0" style="font-size: 25px;">{{getLanguage['S']['QRIMGD1']}}</p>
                                <p class="mb-0 font-weight-bold" style="font-size: 35px">{{getLanguage['S']['QRIMGD2']}} </p>
                            </div>
                        </div>
                    </div>


                    <div style="width:270px;margin:auto;display:block">
                        <h2 class="mb-0 text-white font-weight-bold">
                            {{getLanguage['S']['QRJM']}} <!-- Join GGEarn Member -->
                        </h2>

                        <div class="anim-box center spacer">
                            <!-- empty first child used for corners -->
                            <div></div>
                            <div class="position-relative">
                                <img :src="'data:image/png;base64,' + recuitQRCode" class="img-fluid qrcode" alt="QR Code" width="200" height="200" />
                                <img src="https://media.afb.gg/BackOfficeSiteIco/ggearn-ico.png" class="img-fluid  qrcode-logo"/>
                            </div>
                        </div>


                        <a class="text-white d-block mt-5" href="#" @click="downloadQR">
                            <CButton color="success"
                                     class="btn-block font-weight-bold">
                                {{getLanguage['S']['QRC']}}
                            </CButton>
                        </a>

                        <a class="text-white d-block mt-2" href="#" @click="copyDomainLink()">
                            <CButton color="success"
                                     class="btn-block font-weight-bold">
                                {{getLanguage['S']['SDL']}}
                            </CButton>
                        </a>
                    </div>
                </div>
            </template>

            <div :class="slideinMemberDetail || slideinSearchFilter || slideinMemFreeze || slideinMemBlacklist || slideinEditMemDetail || slideinMemSummary || slideinMemSummary2 || slideinMemDeposit || slideinPLSearchfilter? 'slideinoverlay': ''" @click="closeSlideIn"></div>
            <div :class="slideinMemSummary2 ? 'slideinoverlay': ''" @click="slideinMemSummary2 = false; obj_member2 = {};bool_memberCV2 = false"></div>

            <div class="sliding-div" :class="{ 'is-visible': slideinSearchFilter }" @click.stop style="height:85%">
                <div class="position-relative h-100 overflow-auto">
                    <div class="searchForm">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['DB']['DL']}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :cacheOptions="false"
                                            :defaultOptions="ddDefaultSubBrand"
                                            :load-options="loadSubBrandOptions"
                                            :options="ddSubAgentList"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            :noResultsText="this.getLanguage['GL']['NRF']"
                                            v-model="searchSubAgent"
                                            @input="SubAgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['MEM']['U']}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :cacheOptions="bool_cacheOptionValue"
                                            :load-options="loadMemberOptions"
                                            :options="ddMemberList"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.U')"
                                            v-model="searchUsername" />
                            </div>
                            <div class='searchCol'>
                                <span class="searchLabel">{{this.getLanguage['MEM']['RTS']}} {{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="searchRegisterDtRange"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchRegisterDtRange.startDate != ''">
                                            <CInput size="sm"
                                                    :value="searchRegisterDtRange.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('RSD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('RSD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" @click="clearDateRangeFilter('searchRegisterDtRange')">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class="searchLabel">{{this.getLanguage['MEM']['RTS']}} {{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="searchRegisterDtRange"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchRegisterDtRange.endDate != ''">
                                            <CInput size="sm"
                                                    :value="searchRegisterDtRange.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('RED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('RED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter('searchRegisterDtRange')">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                        </div>

                        <div class="d-flex" style="gap:10px;width:100%;align-items:center;position:absolute;bottom:0">
                            <CButton class='btnReset font-weight-bold m-0' block color="secondary" style=" font-size: 14px !important;" @click="searchSubAgent = null;searchUsername = null;clearDateRangeFilter('searchRegisterDtRange')"><span>{{this.getLanguage['BTN']['RS']}}</span></CButton>
                            <CButton v-shortkey="['enter']" ref="search" @shortkey="getMemberList()" class='searchBtn font-weight-bold m-0' block color="success" @click="getMemberList()" style=" font-size: 14px !important;"><span>{{this.getLanguage['GL']['CONFIRM']}}</span></CButton>
                        </div>
                    </div>
                </div>
            </div>

            <div class="sliding-div" :class="{ 'is-visible': slideinMemberDetail }" @click.stop>
                <div class="position-relative h-100 overflow-auto">
                    <h2 class="text-white font-weight-bold">{{this.getLanguage['SMB']['M']}} {{getLanguage['GL']['D']}}</h2>

                    <div class="sliding-item">
                        <div class="sliding-item-title">{{getLanguage['MEM']['ACC']}}</div>
                        <div class="sliding-item-desc" :class="obj_member.RS == 1? 'blacklist-member': obj_member.RS == 3? 'freeze-member': ''">{{obj_member.U}}</div>
                    </div>
                    <div class="sliding-item">
                        <div class="sliding-item-title">{{getLanguage['MEM']['CBL']}}</div>
                        <div class="sliding-item-desc">{{ formatNumber(obj_member.CBL, 2, obj_member.CS) }}</div>
                    </div>
                    <div class="sliding-item">
                        <div class="sliding-item-title">{{getLanguage['MEM']['LLT']}}</div>
                        <div class="sliding-item-desc">
                            <template v-if="obj_member.LLTS">
                                {{obj_member.LLTS | moment('DD MMM YYYY HH:mm:ss')}}
                            </template>
                            <template v-else>
                                {{getLanguage['MEM']['NRLLT']}}
                            </template>
                        </div>
                    </div>
                    <!--<div class="sliding-item amt" v-if="getUserInfo.AT === 4 && checkModuleAccess('MD', 'D', constAccessType.add)">
                        <div class="sliding-item-title">{{getLanguage['MEM']['DA']}}</div>
                        <div class="sliding-item-desc">
                            <CInput type="number" placeholder="0" size="sm" v-model="obj_member.depositAmt">
                                <template #prepend>
                                    <CButton size="sm"
                                             type="button"
                                             color="primary"
                                             style="min-width: auto; z-index: 0;">
                                        {{obj_member.CS}}
                                    </CButton>
                                </template>
                                <template #append>
                                    <CButton size="sm"
                                             type="submit"
                                             color="primary"
                                             style="min-width: auto; z-index: 0; background: #62d167  !important; border-color: #62d167  !important;"
                                             @click="transactionShortcut(obj_member, 1)">
                                        <span><i class="fa fa-paper-plane m-0"></i></span>
                                    </CButton>
                                </template>
                            </CInput>
                        </div>
                    </div>-->
                    <!--<div class="sliding-item amt" v-if="getUserInfo.AT === 4 && checkModuleAccess('MW', 'W', constAccessType.add)">
                        <div class="sliding-item-title">{{getLanguage['MEM']['WA']}}</div>
                        <div class="sliding-item-desc">
                            <CInput type="number" placeholder="0" size="sm" v-model="obj_member.withdrawAmt">
                                <template #prepend>
                                    <CButton size="sm"
                                             type="button"
                                             color="primary"
                                             style="min-width: auto; z-index: 0;">
                                        {{obj_member.CS}}
                                    </CButton>
                                </template>
                                <template #append>
                                    <CButton size="sm"
                                             type="submit"
                                             color="primary"
                                             style="min-width: auto; z-index: 0; background: #62d167  !important; border-color: #62d167  !important;"
                                             @click="transactionShortcut(obj_member, 2)">
                                        <span><i class="fa fa-paper-plane m-0"></i></span>
                                    </CButton>
                                </template>
                            </CInput>
                        </div>
                    </div>-->
                    <!--<div class="sliding-item" v-if="getUserInfo.AT === 4 && checkModuleAccess('DLSS', 'P', constAccessType.view)">
                <div class="sliding-item-title">{{getLanguage['MEM']['DLS']}}</div>
                <div class="sliding-item-desc">
                    <CButton v-if="!obj_member.IOL || getUserInfo.IOL"
                             size="sm"
                             type="submit"
                             :class="obj_member.HADLS ? 'btn-danger btn-block' : 'btn-success  btn-block'"
                             :disabled="obj_member.HADLS"
                             @click="(isSENS == 1 && obj_member.AGI == curAGI) ? manualTriggerDLS(obj_member) : null">
                        <span>
                            <span><i class="fa fa-power-off m-0" aria-hidden="true"></i></span>
                        </span>
                        <div class="spinner-border spinner-border-sm" v-if="obj_member.bool_sendLoading"></div>
                    </CButton>
                </div>
            </div>-->
                    <div class="mt-3" v-if="(ML_E|| ML_D)">
                        <div class="" style="gap: 5px; grid-template-columns: repeat(4, 1fr); display: grid;">
                            <div v-if="ML_E && ((isSENS == 1 && obj_member.AGI == curAGI) || isSENS == 0)" class="member-list-same mt-1" @click='editMember(obj_member)'>
                                <i class="cil-color-border"></i> <!--here Edit -->
                            </div>
                            <div v-else-if="ML_E && isSENS == 1 && obj_member.AGI != curAGI" class="member-list-same mt-1">
                                <i class="cil-color-border"></i> <!--here Edit -->
                            </div>

                            <div class="member-list-same mt-1" v-if="checkModuleAccess3(constAccessType.edit) && obj_member.RS == 1 &&  ((isSENS == 1 && obj_member.AGI == curAGI) || isSENS == 0)" @click='unBlacklistMember(obj_member)'>
                                <i class="cil-action-undo"></i> <!--here Remove -->
                            </div>
                            <div class="member-list-same mt-1" v-else-if="checkModuleAccess3(constAccessType.edit) && obj_member.RS == 1 && isSENS == 1 && obj_member.AGI != curAGI">
                                <i class="cil-action-undo"></i> <!--here Remove -->
                            </div>
                            <div v-if="checkModuleAccess3(constAccessType.add) && ML_D && obj_member.RS != 1 &&  ((isSENS == 1 && obj_member.AGI == curAGI) || isSENS == 0)" class="member-list-same mt-1 blacklist-member" @click='blacklistMember(obj_member)'>
                                <i class="cil-ban"></i> <!--here Remove -->
                            </div>
                            <div v-else-if="checkModuleAccess3(constAccessType.add) && ML_D && obj_member.RS != 1 && isSENS == 1 && obj_member.AGI != curAGI" class="member-list-same mt-1">
                                <i class="cil-ban"></i> <!--here Remove -->
                            </div>

                            <div class="member-list-same mt-1" v-if="checkModuleAccess3(constAccessType.edit) && obj_member.RS == 3 && ((isSENS == 1 && obj_member.AGI == curAGI) || isSENS == 0)" @click='unFreezeMember(obj_member)'>
                                <i class="cil-action-undo"></i> <!--here Freeze -->
                            </div>
                            <div class="member-list-same mt-1" v-else-if="checkModuleAccess3(constAccessType.edit) && obj_member.RS == 3 && isSENS == 1 && obj_member.AGI != curAGI">
                                <i class="cil-action-undo"></i> <!--here Freeze -->
                            </div>
                            <div v-if="checkModuleAccess3(constAccessType.add) && ML_D && obj_member.RS != 3 &&  ((isSENS == 1 && obj_member.AGI == curAGI) || isSENS == 0)" class="member-list-same mt-1 freeze-member" @click='freezeMember(obj_member)'>
                                <i class="cil-snowflake"></i> <!--here Freeze -->
                            </div>
                            <div v-else-if="checkModuleAccess3(constAccessType.add) && ML_D && obj_member.RS != 3 && isSENS == 1 && obj_member.AGI != curAGI" class="member-list-same mt-1">
                                <i class="cil-snowflake"></i> <!--here Freeze -->
                            </div>
                        </div>
                    </div>

                    <div class="slidlingbtn">
                        <CButton color="success" block @click="slideinMemberDetail = false">
                            {{this.getLanguage["BTN"]["CLO"]}}
                        </CButton>
                    </div>
                </div>
            </div>

            <div class="sliding-div" :class="{ 'is-visible': slideinMemFreeze }" @click.stop>
                <div class="position-relative h-100 overflow-auto">
                    <h2 class="text-white font-weight-bold">{{this.getLanguage['MEM']['AF']}}</h2>
                    <div class="sliding-item">
                        <div class="sliding-item-title">{{getLanguage['MEM']['FRR']}}<span class="required" /></div>
                        <div class="sliding-item-desc">
                            <treeselect :multiple="false"
                                        :options="dd_rejectreasonF"
                                        :placeholder="getLanguage['MEM']['FRR']"
                                        v-model="obj_RejectF.reason"
                                        openDirection="below"
                                        :limit="1"
                                        :limitText="count => `+${count}`" />
                            <span class="ErrMsg">{{ ValidationFreezeErrMsg('reason2') }}</span>
                        </div>
                    </div>
                    <div class="sliding-item" v-if="obj_RejectF.reason==999">
                        <div class="sliding-item-title">{{getLanguage['DB']['RB']}}<span class="required" /> </div>
                        <div class="sliding-item-desc">
                            <CInput class="" :placeholder="getLanguage['MTA']['FRR']" size="sm" :value="obj_RejectF.reason2" @change="v => obj_RejectF.reason2 = v" :disabled="obj_RejectF.reason!=999" maxlength="300"></CInput>
                        </div>
                    </div>

                    <div class="btngroup">
                        <CButton block color="secondary" class='font-weight-bold m-0' @click="slideinMemFreeze = false;"><span>{{this.getLanguage['BTN']['CLO']}}</span></CButton>
                        <CButton block color="success" class='font-weight-bold m-0' @shortkey="saveFreeze()" @click="saveFreeze()"><span>{{this.getLanguage['BTN']['SV']}}</span></CButton>
                    </div>
                </div>
            </div>

            <div class="sliding-div" :class="{ 'is-visible': slideinMemBlacklist }" @click.stop>
                <div class="position-relative h-100 overflow-auto">
                    <h2 class="text-white font-weight-bold">{{this.getLanguage['MEM']['ABL']}}</h2>
                    <div class="sliding-item">
                        <div class="sliding-item-title">{{getLanguage['MEM']['RR']}}<span class="required" /></div>
                        <div class="sliding-item-desc">
                            <treeselect :multiple="false"
                                        :options="dd_rejectreason"
                                        :placeholder="getLanguage['MEM']['RR']"
                                        v-model="obj_Reject.reason"
                                        openDirection="below"
                                        :limit="1"
                                        :limitText="count => `+${count}`" />
                            <span class="ErrMsg">{{ ValidationBlackListErrMsg('reason2') }}</span>
                        </div>
                    </div>
                    <div class="sliding-item" v-if="obj_Reject.reason==999">
                        <div class="sliding-item-title">{{getLanguage['DB']['RB']}}<span class="required" /> </div>
                        <div class="sliding-item-desc">
                            <CInput class="" :placeholder="getLanguage['MTA']['FRR']" size="sm" :value="obj_Reject.reason2" @change="v => obj_Reject.reason2 = v" :disabled="obj_Reject.reason!=999" maxlength="300"></CInput>
                        </div>
                    </div>

                    <div class="btngroup">
                        <CButton block color="secondary" class='font-weight-bold m-0' @click="slideinMemBlacklist = false;"><span>{{this.getLanguage['BTN']['CLO']}}</span></CButton>
                        <CButton block color="success" class='font-weight-bold m-0' @shortkey="saveBlacklist()" @click="saveBlacklist()"><span>{{this.getLanguage['BTN']['SV']}}</span></CButton>
                    </div>
                </div>
            </div>

            <div class="sliding-div" :class="{ 'is-visible': slideinMemDeposit }" @click.stop>
                <div class="position-relative h-100 overflow-auto">
                    <h2 class="text-white font-weight-bold" style="word-break: break-word;">{{this.strTnxConfirm}}</h2>

                    <form>
                        <!--<div class="sliding-item">
                    <div class="sliding-item-title">{{this.getLanguage["MEM"]["PROMO"]}}</div>
                    <div class="sliding-item-desc">
                        <treeselect :multiple="false"
                                    :key="rtPromoKey"
                                    :options="dd_promotion"
                                    :auto-load-root-options="false"
                                    :placeholder="getLanguage['MEM']['PROMO']"
                                    class="inline"
                                    v-model="obj_OutletTran['PI']" />
                    </div>
                </div>-->
                        <div class="sliding-item">
                            <div class="sliding-item-title">{{this.getLanguage["MEM"]["UREC"]}} </div>
                            <div class="sliding-item-desc">
                                <input type="file" name="pic" accept="image/*, .pdf" @change="onFileSelected" style="overflow: hidden;" />
                            </div>
                        </div>
                    </form>

                    <div class="btngroup">
                        <CButton block color="secondary" class='font-weight-bold m-0' @click="slideinMemDeposit = false;"><span>{{this.getLanguage['BTN']['CLO']}}</span></CButton>
                        <CButton block color="success" class='font-weight-bold m-0' @shortkey="processTransaction()" @click="processTransaction()"><span>{{this.getLanguage['BTN']['SV']}}</span></CButton>
                    </div>
                </div>
            </div>

            <div class="sliding-div" :class="{ 'is-visible': slideinEditMemDetail }" @click.stop>
                <div class="position-relative h-100 overflow-auto">
                    <h2 class="text-white font-weight-bold">{{this.getLanguage["MEM"][obj_member.I > 0? "EDTM": "ADDM"]}}</h2>

                    <form>
                        <div class="sliding-item">
                            <div class="sliding-item-title">{{getLanguage['MEM']['U']}}<span class="required" /></div>
                            <div class="sliding-item-desc">
                                <CInput type="text" size="sm" :disabled="obj_member.I > 0" vertical :placeholder="this.getLanguage['MEM']['U']" :value="obj_member.U" @change="v => obj_member.U = v" ref="U" autocomplete="username"></CInput>
                                <span class="ErrMsg">{{ ValidationMemberErrMsg('U') }}</span>
                            </div>
                        </div>
                        <!--<div class="sliding-item" v-if="getUserInfo.AT == 4">
                    <div class="sliding-item-title">{{getLanguage['MEM']['EAR']}} </div>
                    <div class="sliding-item-desc">
                        <label class="switch">
                            <input type="checkbox" :checked="obj_member['ARS']" @change="v => obj_member['ARS'] = v.target.checked" />
                            <span class="slider round"></span>
                        </label>
                    </div>
                </div>
                <div class="sliding-item" v-if="getUserInfo.AT == 4">
                    <div class="sliding-item-title">{{getLanguage['MEM']['EAFF']}} </div>
                    <div class="sliding-item-desc">
                        <label class="switch">
                            <input type="checkbox" :checked="obj_member['AS']" @change="v => obj_member['AS'] = v.target.checked" />
                            <span class="slider round"></span>
                        </label>
                    </div>
                </div>-->
                        <div class="sliding-item">
                            <div class="sliding-item-title">{{getLanguage['MEM']['UP']}} </div>
                            <div class="sliding-item-desc">
                                <CInput :type="isShowPassword ? 'text' : 'password'" size="sm" :placeholder="getLanguage['MEM']['UP']" v-model="obj_member.UP" autocomplete="new-password">
                                    <template #append>
                                        <CButton size="sm"
                                                 type="button"
                                                 color="primary"
                                                 @click="isShowPassword = !isShowPassword"
                                                 style=" min-width: 40px; z-index: 0; background: #fff !important; border: none !important;color:#000 !important">
                                            <i class="fa fa-eye" v-if="isShowPassword"></i>
                                            <i class="fa fa-eye-slash" v-else></i>
                                        </CButton>
                                    </template>
                                </CInput>
                                <span class="ErrMsg">{{ ValidationMemberErrMsg('UP') }}</span>
                            </div>
                        </div>
                        <div class="sliding-item">
                            <div class="sliding-item-title">{{getLanguage['MEM']['CUP']}} </div>
                            <div class="sliding-item-desc">
                                <CInput :type="isShowConfirmPassword ? 'text' : 'password'" size="sm" :placeholder="getLanguage['MEM']['CUP']" v-model="obj_member.CUP" autocomplete="confirm-password">
                                    <template #append>
                                        <CButton size="sm"
                                                 type="button"
                                                 color="primary"
                                                 @click="isShowConfirmPassword = !isShowConfirmPassword"
                                                 style=" min-width: 40px; z-index: 0; background: #fff !important; border: none !important; color: #000 !important">
                                            <i class="fa fa-eye" v-if="isShowConfirmPassword"></i>
                                            <i class="fa fa-eye-slash" v-else></i>
                                        </CButton>
                                    </template>
                                </CInput>
                                <span class="ErrMsg">{{ ValidationMemberErrMsg('CUP') }}</span>
                            </div>
                        </div>
                        <!--<div class="sliding-item">
                    <div class="sliding-item-title">{{getLanguage['MEM']['MTI']}} </div>
                    <div class="sliding-item-desc">
                        <treeselect :multiple="false"
                                    :load-options="loadEditMemberTypeOptions"
                                    :noOptionsText="this.getLanguage['GL']['NOA']"
                                    :options="ddEditMemberTypeList"
                                    :auto-load-root-options="convertToBool(obj_member.I > 0 && obj_member.MTI)"
                                    :placeholder="this.utilGetDDLanguage('MEM.MTI')"
                                    v-model="obj_member.MTI" />
                    </div>
                </div>-->
                        <!--<div class="sliding-item" v-if="obj_member.I <= 0">
                    <div class="sliding-item-title">{{getLanguage['MEM']['CI']}}<span class="required" />  </div>
                    <div class="sliding-item-desc">
                        <treeselect :multiple="false"
                                    :load-options="loadEditMemberCurrencyOptions"
                                    :options="ddEditMemberCurrencyList"
                                    :auto-load-root-options="false"
                                    :disable-branch-nodes="true"
                                    :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                    v-model="obj_member.CI"
                                    @input="MemberCurrencyChange"
                                    ref="CI" />
                        <span class="ErrMsg">{{ ValidationMemberErrMsg('CI') }}</span>
                    </div>
                </div>-->
                    </form>

                    <div class="btngroup">
                        <CButton block color="secondary" class='font-weight-bold m-0' @click="slideinEditMemDetail = false;"><span>{{this.getLanguage['BTN']['CLO']}}</span></CButton>
                        <CButton block color="success" class='font-weight-bold m-0' @shortkey="saveMember()" @click="saveMember()"><span>{{this.getLanguage['BTN']['SV']}}</span></CButton>
                    </div>
                </div>
            </div>

            <div class="sliding-div" :class="{ 'is-visible': slideinMemSummary }" @click.stop>
                <div class="position-relative h-100 overflow-auto">
                    <h2 class="text-white font-weight-bold">{{this.getLanguage['DB']['M']}} {{getLanguage['AG']['S']}}</h2>

                    <div class="sliding-item">
                        <div class="sliding-item-title">{{this.getLanguage['MEM']['U']}}</div>
                        <div class="sliding-item-desc">{{obj_member.U}}</div>
                    </div>
                    <div class="sliding-item" v-if="obj_member.UP">
                        <div class="sliding-item-title">{{this.getLanguage['MEM']['UP']}} </div>
                        <div class="sliding-item-desc">{{obj_member.UP}}</div>
                    </div>
                    <div class="sliding-item">
                        <div class="sliding-item-title">{{this.getLanguage['MEM']['CI']}} </div>
                        <div class="sliding-item-desc">{{obj_member.CS}}</div>
                    </div>
                    <div class="sliding-item" v-if="obj_member.E">
                        <div class="sliding-item-title">{{this.getLanguage["MEM"]["E"]}} </div>
                        <div class="sliding-item-desc">{{obj_member.E}}</div>
                    </div>
                    <div class="sliding-item" v-if="obj_member.PN">
                        <div class="sliding-item-title">{{this.getLanguage["MEM"]["PN"]}} </div>
                        <div class="sliding-item-desc">{{obj_member.PN}}</div>
                    </div>

                    <CRow class="recruit mt-3">
                        <CCol col="12">
                            <div class="custom-carousel"
                                 @touchstart="handleTouchStart"
                                 @touchmove="handleTouchMove"
                                 @touchend="handleTouchEnd">
                                <!--<ol class="carousel-indicators">
                            <li :class="{ active: index === currentSlide }" v-for="(slide, index) in 2"></li>
                        </ol>-->
                                <div class="carousel-inner text-center">
                                    <div v-for="(slide, index) in 2"
                                         :key="index"
                                         class="carousel-item"
                                         :class="{ active: index === currentSlide }">
                                        <div class="slide-content w-100" v-if="index == 0" :key="0">
                                            <div className="" style="width: 100%; display: grid; grid-template-columns: repeat(5, 1fr); gap: 15px;">
                                                <div class="mb-3 px-0" @click="copyMemberLink()">
                                                    <div class="copyLink-icon m-auto d-flex justify-content-center align-items-center text-white"><i class="fa-solid fa-link" aria-hidden="true"></i></div>
                                                    <small class="text-white">{{getLanguage['BTN']['C']}}</small>
                                                </div>
                                                <div class="mb-3 px-0">
                                                    <a class="text-white" :href="'https://t.me/share/?url='+ message" target="_blank">
                                                        <div class="telegram-icon m-auto d-flex justify-content-center align-items-center"><i class="fa-brands fa-telegram" aria-hidden="true"></i></div>
                                                        <small>{{getLanguage['CU']['PT2']}}</small>
                                                    </a>
                                                </div>
                                                <!--<div class="mb-3 px-0">
                                            <a class="text-white" :href="'https://twitter.com/intent/tweet?url='+ message" target="_blank">
                                                <div class="twitter-icon m-auto d-flex justify-content-center align-items-center"><i class="fa-brands fa-twitter" aria-hidden="true"></i></div>
                                                <small>{{getLanguage['CU']['PT14']}}</small>
                                            </a>
                                        </div>-->
                                                <div class="mb-3 px-0">
                                                    <a class="text-white" :href="'https://wa.me/?text='+ message " target="_blank">
                                                        <div class="whatsapp-icon m-auto d-flex justify-content-center align-items-center"><i class="fa-brands fa-whatsapp" aria-hidden="true"></i></div>
                                                        <small>{{getLanguage['CU']['PT1']}}</small>
                                                    </a>
                                                </div>
                                                <div class="mb-3 px-0">
                                                    <a class="text-white" :href="'https://line.me/R/share?text='+ message" target="_blank">
                                                        <div class="line-icon m-auto d-flex justify-content-center align-items-center"><i class="fa-brands fa-line" aria-hidden="true"></i></div>
                                                        <small>{{getLanguage['CU']['PT5']}}</small>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="slide-content w-100" v-if="index == 1" :key="1">
                                            <div className="" style="width: 100%; display: grid; grid-template-columns: repeat(5, 1fr); gap: 15px;">
                                                <!--<div class="mb-3 px-0">
                                            <a class="text-white" :href="'https://www.linkedin.com/sharing/share-offsite/?url='+ message" target="_blank">
                                                <div class="instagram-icon m-auto d-flex justify-content-center align-items-center"><i class="fa-brands fa-linkedin"></i></div>
                                                <small>{{getLanguage['CU']['PT9']}}</small>
                                            </a>
                                        </div>-->
                                                <!--<div class="mb-3 px-0">
                                            <a class="text-white" :href="skypeLink()" target="_blank">
                                                <div class="skype-icon m-auto d-flex justify-content-center align-items-center"><i class="fa-brands fa-skype" aria-hidden="true"></i></div>
                                                <small>{{getLanguage['SUB']['SKYPE']}}</small>
                                            </a>
                                        </div>-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CCol>
                    </CRow>

                    <div class="slidlingbtn">
                        <CButton color="success" block @click="slideinMemSummary = false;">
                            {{this.getLanguage["BTN"]["CLO"]}}
                        </CButton>
                    </div>
                </div>
            </div>

            <div class="sliding-div" :class="{ 'is-visible': slideinPLSearchfilter }" @click.stop style="height:85%">
                <div class="position-relative h-100 overflow-auto">
                    <div class="searchForm">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['DB']['DL']}}  :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :load-options="loadSubBrandOptions2"
                                            :cacheOptions="false"
                                            :defaultOptions="ddDefaultSubBrand"
                                            :noResultsText="this.getLanguage['GL']['NRF']"
                                            :options="ddSubAgentList2"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            v-model="searchSubAgent2"
                                            openDirection="below"
                                            @input="SubAgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["U"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :cacheOptions="bool_cacheOptionValue"
                                            :load-options="loadMemberOptions2"
                                            :options="ddMemberList2"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.U')"
                                            v-model="searchUsername2" />

                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.startDate != ''">
                                            <CInput size="sm"
                                                    :value="searchCreatedTS.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter('searchCreatedTS')">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.endDate != ''">
                                            <CInput size="sm"
                                                    :value="searchCreatedTS.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter('searchCreatedTS')">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <!--<div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["CTCI"]}} :</span>
                                <treeselect :multiple="false"
                                            :load-options="loadCurrencyOptions"
                                            :options="ddCurrencyList"
                                            :auto-load-root-options="true"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="searchCurrency" />
                            </div>-->
                        </div>
                        <div class="d-flex" style="gap:10px;width:100%;align-items:center;position:absolute;bottom:0">
                            <CButton class='btnReset font-weight-bold m-0' block color="secondary" style=" font-size: 14px !important;" @click="searchSubAgent2 = null;searchUsername2 = null;clearDateRangeFilter('searchCreatedTS')"><span>{{this.getLanguage['BTN']['RS']}}</span></CButton>
                            <CButton v-shortkey="['enter']" ref="search" @shortkey="getMemberProfitLossList()" class='searchBtn font-weight-bold m-0' block color="success" @click="getMemberProfitLossList()" style=" font-size: 14px !important;"><span>{{this.getLanguage['GL']['CONFIRM']}}</span></CButton>
                        </div>
                    </div>
                </div>
            </div>

            <div class="sliding-div" :class="{ 'is-visible': slideinMemSummary2 }" @click.stop>
                <div class="position-relative h-100 overflow-auto">
                    <h2 class="text-white font-weight-bold">{{this.getLanguage['DB']['M']}} {{getLanguage['AG']['S']}}</h2>

                    <div class="sliding-item">
                        <div class="sliding-item-title">{{this.getLanguage['MEM']['U']}}</div>
                        <div class="sliding-item-desc">{{obj_member2.U}}</div>
                    </div>
                    <div class="sliding-item">
                        <div class="sliding-item-title">{{this.getLanguage['MEM']['UP']}} </div>
                        <div class="sliding-item-desc">{{obj_member2.UP}}</div>
                    </div>
                    <div class="sliding-item">
                        <div class="sliding-item-title">{{this.getLanguage['MEM']['CI']}} </div>
                        <div class="sliding-item-desc">{{currency}}</div>
                    </div>
                    <div class="sliding-item" v-if="obj_member2.E">
                        <div class="sliding-item-title">{{this.getLanguage["MEM"]["E"]}} </div>
                        <div class="sliding-item-desc">{{obj_member2.E}}</div>
                    </div>
                    <div class="sliding-item" v-if="obj_member2.PN">
                        <div class="sliding-item-title">{{this.getLanguage["MEM"]["PN"]}} </div>
                        <div class="sliding-item-desc">{{obj_member2.PN}}</div>
                    </div>

                    <CRow class="recruit mt-3">
                        <CCol col="12">
                            <div class="custom-carousel"
                                 @touchstart="handleTouchStart"
                                 @touchmove="handleTouchMove"
                                 @touchend="handleTouchEnd">
                                <!--<ol class="carousel-indicators">
                            <li :class="{ active: index === currentSlide }" v-for="(slide, index) in 2"></li>
                        </ol>-->
                                <div class="carousel-inner text-center">
                                    <div v-for="(slide, index) in 2"
                                         :key="index"
                                         class="carousel-item"
                                         :class="{ active: index === currentSlide }">
                                        <div class="slide-content w-100" v-if="index == 0" :key="0">
                                            <div className="" style="width: 100%; display: grid; grid-template-columns: repeat(5, 1fr); gap: 15px;">
                                                <div class="mb-3 px-0" @click="copyMemberLink()">
                                                    <div class="copyLink-icon m-auto d-flex justify-content-center align-items-center text-white"><i class="fa-solid fa-link" aria-hidden="true"></i></div>
                                                    <small class="text-white">{{getLanguage['BTN']['C']}}</small>
                                                </div>
                                                <div class="mb-3 px-0">
                                                    <a class="text-white" :href="'https://t.me/share/?url='+ message" target="_blank">
                                                        <div class="telegram-icon m-auto d-flex justify-content-center align-items-center"><i class="fa-brands fa-telegram" aria-hidden="true"></i></div>
                                                        <small>{{getLanguage['CU']['PT2']}}</small>
                                                    </a>
                                                </div>
                                                <!--<div class="mb-3 px-0">
                                                    <a class="text-white" :href="'https://twitter.com/intent/tweet?url='+ message" target="_blank">
                                                        <div class="twitter-icon m-auto d-flex justify-content-center align-items-center"><i class="fa-brands fa-twitter" aria-hidden="true"></i></div>
                                                        <small>{{getLanguage['CU']['PT14']}}</small>
                                                    </a>
                                                </div>-->
                                                <div class="mb-3 px-0">
                                                    <a class="text-white" :href="'https://wa.me/?text='+ message " target="_blank">
                                                        <div class="whatsapp-icon m-auto d-flex justify-content-center align-items-center"><i class="fa-brands fa-whatsapp" aria-hidden="true"></i></div>
                                                        <small>{{getLanguage['CU']['PT1']}}</small>
                                                    </a>
                                                </div>
                                                <div class="mb-3 px-0">
                                                    <a class="text-white" :href="'https://line.me/R/share?text='+ message" target="_blank">
                                                        <div class="line-icon m-auto d-flex justify-content-center align-items-center"><i class="fa-brands fa-line" aria-hidden="true"></i></div>
                                                        <small>{{getLanguage['CU']['PT5']}}</small>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="slide-content w-100" v-if="index == 1" :key="1">
                                            <div className="" style="width: 100%; display: grid; grid-template-columns: repeat(5, 1fr); gap: 15px;">
                                                <!--<div class="mb-3 px-0">
                                            <a class="text-white" :href="'https://www.linkedin.com/sharing/share-offsite/?url='+ message" target="_blank">
                                                <div class="instagram-icon m-auto d-flex justify-content-center align-items-center"><i class="fa-brands fa-linkedin"></i></div>
                                                <small>{{getLanguage['CU']['PT9']}}</small>
                                            </a>
                                        </div>-->
                                                <!--<div class="mb-3 px-0">
                                            <a class="text-white" :href="skypeLink()" target="_blank">
                                                <div class="skype-icon m-auto d-flex justify-content-center align-items-center"><i class="fa-brands fa-skype" aria-hidden="true"></i></div>
                                                <small>{{getLanguage['SUB']['SKYPE']}}</small>
                                            </a>
                                        </div>-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CCol>
                    </CRow>

                    <div class="slidlingbtn">
                        <CButton color="success" block @click="slideinMemSummary2 = false;obj_member2 = {};bool_memberCV2 = false">
                            {{this.getLanguage["BTN"]["CLO"]}}
                        </CButton>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import { constAccessType, constRejectReasonBL, constRejectReasonF, constTranType, consDeviceType, consTypeofmember, loadingFullScreen } from '@/modules/Constant.js'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import Loading from 'vue-loading-overlay';
    import moment from "moment";
    import 'vue-loading-overlay/dist/vue-loading.css';
    import genericHelper from "@/modules/GenericHelper.js";
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { mapGetters, mapActions } from 'vuex';
    import { required, email, sameAs, requiredIf, alphaNum, decimal, minValue, numeric } from 'vuelidate/lib/validators'
    import Vue from 'vue'
    import Sortable from 'sortablejs';
    import draggable from 'vuedraggable';
    import $ from 'jquery'
    import html2canvas from 'html2canvas';
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            Sortable,
            draggable,
            html2canvas,
        },
        data() {
            return {
                // Pagination and Counters
                int_RC: 200,
                int_Total: 0,
                int_Page: 1,
                int_IC: 1,
                int_TP: 0,

                // UI State
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen,
                bool_isMobileDevice: false,
                slideinSearchFilter: false,
                slideinEditMemDetail: false,
                slideinMemBlacklist: false,
                slideinMemFreeze: false,
                slideinMemberDetail: false,
                slideinMemSummary: false,
                slideinMemSummary2: false,
                slideinMemDeposit: false,
                slideinPLSearchfilter: false,
                isShowDetails: true,
                isShowPL: false,
                isShowForm: false,
                isShowQR: false,

                // Sorting and Dropdowns
                str_tableSortBy: "",
                bool_isSort: true,
                str_tableSortBy2: "TA",
                bool_isSort2: true,
                //ddAgentList: null,
                ddSubAgentList: null,
                ddSubAgentList2: null,
                ddDefaultSubBrand: [],
                ddMemberRankList: null,
                ddMemberList: [],
                ddMemberList2: [],
                ddDefaultMemberList: [],
                ddEditMemberTypeList: [],
                ddEditMemberCurrencyList: [],
                ddEditMemberCurrencyList2: [],
                ddCurrencyList : null,
                // Search Filters
                searchAgi: null,
                searchSAgi: null,
                searchCurrency: null,
                searchAgent: null,
                searchSubAgent: null,
                searchUsername: null,
                searchExcludeSubAgent: false,
                searchSubAgent2: null,
                searchUsername2: null,
                searchMemberStatus: 2,
                searchRegisterDtRange: { startDate: "", endDate: "" },
                searchCreatedTS: { startDate: this.getMonthStartDate(), endDate: this.getMonthEndDate() },
                searchCreatedTS2: { startDate: this.getMonthStartDate(), endDate: this.getMonthEndDate() },
                // Member and Data Lists
                arr_MemberList: [],
                arr_mainProfitLossList: [],
                arr_profitLossList: [],
                arr_FV: { "AGI": null },
                obj_member: {},
                obj_member2: {},
                bool_blacklistCV: false,
                bool_freezeCV: false,
                bool_memberCV: false,
                bool_memberCV2: false,

                // Access Control
                constAccessType: constAccessType,
                ML_A: false,
                ML_E: false,
                ML_D: false,
                MBA_A: false,
                isSubAgent: false,

                // Rejection and Blacklist Data
                dd_rejectreason: [],
                dd_rejectreasonF: [],
                obj_blacklist: {},
                obj_freeze: {},
                obj_Reject: { reason: null, reason2: "" },
                obj_RejectF: { reason: null, reason2: "" },

                // Outlet Transactions and Promotions
                obj_OutletTran: [],
                obj_OutletTran2: [],
                obj_ManualPromo: { AGI: 0, CNT: "", CNM: "", R: [] },
                bool_EnableAffiliate: false,
                rtAffiliateKey: 0,
                rtSubBrand: 0,
                dd_promotion: [],
                rtPromoKey: 0,
                strTnxConfirm: "",
                selectedFile: null,

                // Messaging and Swiping
                message: null,
                currentSlide: 0,
                startX: 0,
                endX: 0,
                startTime: 0,
                threshold: 50,
                timeThreshold: 800,
                isSwiping: false,

                // Password Toggles
                isShowPassword: false,
                isShowConfirmPassword: false,

                // Cache and Miscellaneous
                bool_cacheOptionValue: true,
                recuitQRCode: null,
                currency: null,

                registerDomainUrl: null,
            }
        },
        methods: {
            ...mapActions('UserInfo', ['setSearchCriteriaAGI']),
            ...mapActions('CurrencyInfo', ['setThousandCurrency']),
            DateTimeChange(type, event) {
                if (type == "RSD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchRegisterDtRange.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.searchRegisterDtRange.startDate = "";
                    }
                }
                if (type == "RED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchRegisterDtRange.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.searchRegisterDtRange.endDate = "";
                    }
                }
                if (type == "DSD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchLDepositDtRange.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.searchLDepositDtRange.startDate = "";
                    }
                }
                if (type == "DED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchLDepositDtRange.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.searchLDepositDtRange.endDate = "";
                    }
                }
                if (type == "BD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchBirthday.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.searchBirthday.startDate = "";
                    }
                }
            },
            checkModuleAccess3(type) {
                return this.checkModuleAccess('BLL', 'M', type);
            },
            ctrPage(newPage) {
                this.int_Page = newPage;
                if (newPage > this.int_TP) {
                    this.int_Page = this.int_TP;
                }
                if (newPage <= 0) {//here set the limit of the label num
                    this.int_Page = 1;
                }
                this.int_IC = this.int_Page;
                this.getMemberList();
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            clearDateRangeFilter(value) {
                if (value == 'searchBirthday') {
                    this.searchBirthday = {
                        startDate: null,
                        endDate: null
                    };
                }
                else if (value == 'searchRegisterDtRange') {
                    this.searchRegisterDtRange = {
                        startDate: "",
                        endDate: ""
                    };
                }
                else if (value == 'searchLDepositDtRange') {
                    this.searchLDepositDtRange = {
                        startDate: "",
                        endDate: ""
                    };
                }
                else if (value == 'searchCreatedTS') {
                    this.searchCreatedTS = {
                        startDate: this.getMonthStartDate(),
                        endDate: this.getMonthEndDate()
                    };
                }
            },
            loadDefaultSubBrand(agi, isFirstLoad = false) {
                var that = this;
                var searchQuery = "0";

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = that.deepClone(d.dropdownlist);
                            if (isFirstLoad) {
                                that.searchSubAgent = that.ddDefaultSubBrand[0].id;
                                that.searchSubAgent2 = that.ddDefaultSubBrand[0].id;
                                that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                                //that.getMemberList();

                                that.dependUrlShowItem();
                            }
                        }
                    });

                this.getDataApi(`/api/dd/cur/${this.getUserInfo.AGI}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddEditMemberCurrencyList2 = d.dropdownlist;

                            if (that.ddEditMemberCurrencyList2.length > 0) {
                                for (var i = 0; i < that.ddEditMemberCurrencyList2.length; i++) {
                                    if (that.ddEditMemberCurrencyList2[i].id == that.getUserInfo.CID) {
                                        that.obj_member2.CI = that.ddEditMemberCurrencyList2[i].id;
                                    }
                                }
                            }
                        }
                        else {
                            that.ddEditMemberCurrencyList2 = null;
                        }
                    });
            },
            SubAgentGroupChangefs(value) {
                if (value) {
                    this.setSearchCriteriaAGI(value);
                    var agi = 0;
                    if (value != "") {
                        agi = value;
                    }
                    this.searchAgi = agi;
                }
                else {
                    this.setSearchCriteriaAGI(null);
                    this.searchAgi = 0;
                }
                this.ddBankBrandList = null;
                this.searchBank = null;
                this.bool_cacheOptionValue = false;
                this.ddTypeName = null;
                this.searchTypeName = null;
                this.ddSearchMemberCurrencyList = null;
            },
            closeSlideIn() {
                this.slideinMemberDetail = false;
                this.slideinSearchFilter = false;
                this.slideinMemFreeze = false;
                this.slideinMemBlacklist = false;
                this.slideinEditMemDetail = false;
                this.slideinMemSummary = false;
                this.slideinMemSummary2 = false;
                this.slideinMemDeposit = false;
                this.slideinPLSearchfilter = false
            },
            dependUrlShowItem() {
                if (this.$route.query.t) {
                    this.isShowDetails = this.$route.query.t == 1 ? true : false;
                    this.isShowPL = this.$route.query.t == 2 ? true : false;
                    this.isShowForm = this.$route.query.t == 3 ? true : false;
                    this.isShowQR = this.$route.query.t == 4 ? true : false;
                    if (this.isShowDetails) {
                        this.getMemberList();
                    } else if (this.isShowPL) {
                        this.getMemberProfitLossList();
                    } else if (this.isShowForm) {

                    } else if (this.isShowQR) {
                        this.generateQRCode();
                    }
                }
            },

            //member detail
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getMemberList();
            },
            setSortLogo(str_TF) {
                return `${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'active cil-sort-descending' : 'active cil-sort-ascending') : 'fa fa-sort'}`;//here change the sort logo
            },
            getMemberList() {
                this.bool_fullLoading = true;
                var that = this;
                var agentGId = null;

                //if (this.searchAgent) {
                //    var agentList = this.searchAgent.split("-");
                //    agentGId = agentList[agentList.length - 1];
                //}

                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                var hasDefaultPath = false;

                if (path) {
                    hasDefaultPath = true;
                }

                if (this.searchSubAgent) {
                    path += "&f.AGI=" + this.searchSubAgent;
                } else if (agentGId) {
                    path += "&f.AGI=" + agentGId;
                }

                if (this.searchUsername) {
                    path += "&f.MI=" + this.searchUsername;
                }

                if (this.searchRegisterDtRange) {
                    if (this.searchRegisterDtRange.startDate != "") {
                        path += "&f.CTS_from=" + this.parseDateToJsonString(this.searchRegisterDtRange.startDate);
                    }

                    if (this.searchRegisterDtRange.endDate != "") {
                        path += "&f.CTS_to=" + this.parseDateToJsonString(this.searchRegisterDtRange.endDate);
                    }
                }

                if (!this.searchSubAgent) {
                    path += "&f.EXSAG=" + this.searchExcludeSubAgent;
                }

                if (!hasDefaultPath && path) {
                    path = path.substring(1);
                }

                this.getDataApi(`/api/m/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.slideinSearchFilter = false;
                            that.int_TP = d.D.TotalPages;
                            that.int_Total = d.D.TotalItems;
                            that.arr_MemberList = d.D.Items ? d.D.Items : [];

                            if (d.D && d.D.Items && d.D.Items.length > 0) {
                                that.isSubAgent = d.D.Items[0].ISA;
                            }
                        }
                    });
            },
            slideInMemberDetail(data) {
                this.obj_member = data;
                this.slideinMemberDetail = true;
            },

            //member profitloss
            setSortTable2(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy2 = SV;
                this.bool_isSort2 = !this.bool_isSort2;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getMemberProfitLossList();
            },
            setSortLogo2(str_TF) {
                return `${this.str_tableSortBy2 == str_TF ? (this.bool_isSort2 ? 'active cil-sort-descending' : 'active cil-sort-ascending') : 'fa fa-sort'}`;//here change the sort logo
            },
            getMemberProfitLossList(loadGrandTotal = true) {
                this.bool_fullLoading = true;
                var that = this;
                //var agentGId = null;

                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy2, this.bool_isSort2);
                var hasDefaultPath = false;

                if (path) {
                    hasDefaultPath = true;
                }

                if (this.searchSubAgent2) {
                    path += "&f.SAGI=" + this.searchSubAgent2;
                    sessionStorage.setItem('TWLBMEM2_FilterSAGI', this.searchSubAgent2);
                }

                if (this.searchUsername2) {
                    path += "&f.MI=" + this.searchUsername2;
                    sessionStorage.setItem('TWLBMEM2_FilterMName', this.searchUsername2);
                }

                if (this.getUserInfo.CID) {
                    path += "&f.CCI=" + this.getUserInfo.CID;
                    sessionStorage.setItem('TWLBMEM2_FilterCI', this.getUserInfo.CID);
                }

                if (this.searchCreatedTS) {
                    if (this.searchCreatedTS.startDate != "") {
                        path += "&f.STS_from=" + this.parseDateToJsonString(this.searchCreatedTS.startDate);
                        sessionStorage.setItem('TWLBMEM2_FilterSTS_from', this.parseDateToJsonString(this.searchCreatedTS.startDate));
                    }

                    if (this.searchCreatedTS.endDate != "") {
                        path += "&f.STS_to=" + this.parseDateToJsonString(this.searchCreatedTS.endDate);
                        sessionStorage.setItem('TWLBMEM2_FilterSTS_to', this.parseDateToJsonString(this.searchCreatedTS.endDate));
                    }
                }
                if (!hasDefaultPath && path) {
                    path = path.substring(1);
                }

                this.getDataApi(`/api/reports/winloss/totalbmem2?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.slideinsearchfilter = false;
                            that.repoerIsCrypto = false;
                            that.temp_providerName = null;

                            that.arr_profitLossList = d.Item1.D.Items;
                            //that.arr_profitLossList = [
                            //    {
                            //        "I": 1001570,
                            //        "U": "poixyagvnd",
                            //        "AGI": 338,
                            //        "AG": "XYAG",
                            //        "SAGGN": "",
                            //        "CI": 91,
                            //        "CS": "₫",
                            //        "CBL": 529700,
                            //        "LLIP": null,
                            //        "PN": null,
                            //        "NND": 0,
                            //        "TND": 0,
                            //        "NMD": 0,
                            //        "TMD": 0,
                            //        "TAND": 0,
                            //        "TAD": 0,
                            //        "NNW": 0,
                            //        "TNW": 0,
                            //        "NMW": 0,
                            //        "TMW": 0,
                            //        "TANW": 0,
                            //        "TAW": 0,
                            //        "NP": 0,
                            //        "TP": 0,
                            //        "NB": 26,
                            //        "TB": 232000,
                            //        "WLA": 368900,
                            //        "TN": "",
                            //        "TC": null,
                            //        "TBC": null,
                            //        "AA": 0,
                            //        "ARA": 0,
                            //        "AD": 0,
                            //        "DLS": 0,
                            //        "TNMTA": 0,
                            //        "PDA": 0,
                            //        "TCD": 0,
                            //        "NPL": 368900,
                            //        "HPL": 0,
                            //        "PWL": -36890,
                            //        "AWL": -332010,
                            //        "TA": 232000,
                            //        "MR": 14,
                            //        "RU": null,
                            //        "BCBA": 232000,
                            //        "BCWLA": 216900,
                            //        "ICT": false,
                            //        "TW": false,
                            //        "HTWT": 0,
                            //        "RP": 0,
                            //        "PKVC": null
                            //    },
                            //    {
                            //        "I": 1001583,
                            //        "U": "test1234vnd",
                            //        "AGI": 4,
                            //        "AG": "TEST AG 1",
                            //        "SAGGN": "",
                            //        "CI": 91,
                            //        "CS": "₫",
                            //        "CBL": 82108.13,
                            //        "LLIP": null,
                            //        "PN": null,
                            //        "NND": 0,
                            //        "TND": 0,
                            //        "NMD": 0,
                            //        "TMD": 0,
                            //        "TAND": 0,
                            //        "TAD": 0,
                            //        "NNW": 0,
                            //        "TNW": 0,
                            //        "NMW": 0,
                            //        "TMW": 0,
                            //        "TANW": 0,
                            //        "TAW": 0,
                            //        "NP": 0,
                            //        "TP": 0,
                            //        "NB": 109,
                            //        "TB": 28001.89,
                            //        "WLA": -17889.78,
                            //        "TN": "",
                            //        "TC": null,
                            //        "TBC": null,
                            //        "AA": 0,
                            //        "ARA": 0,
                            //        "AD": 0,
                            //        "DLS": 0,
                            //        "TNMTA": 0,
                            //        "PDA": 0,
                            //        "TCD": 0,
                            //        "NPL": -17889.78,
                            //        "HPL": 0,
                            //        "PWL": 2683.467,
                            //        "AWL": 15206.313,
                            //        "TA": 28001.89,
                            //        "MR": 14,
                            //        "RU": null,
                            //        "BCBA": 28001.89,
                            //        "BCWLA": -17889.96,
                            //        "ICT": false,
                            //        "TW": false,
                            //        "HTWT": 0,
                            //        "RP": 0,
                            //        "PKVC": "sdcsdcds"
                            //    }
                            //];

                            that.arr_mainProfitLossList = d.Item2;
                            //that.arr_mainProfitLossList = {
                            //    "I": 0,
                            //    "U": null,
                            //    "AGI": 0,
                            //    "AG": null,
                            //    "SAGGN": null,
                            //    "CI": 0,
                            //    "CS": "USD",
                            //    "CBL": 77846.33547049183,
                            //    "LLIP": null,
                            //    "PN": null,
                            //    "NND": 0,
                            //    "TND": 0,
                            //    "NMD": 0,
                            //    "TMD": 0,
                            //    "TAND": 1,
                            //    "TAD": 68.97170091111617,
                            //    "NNW": 0,
                            //    "TNW": 0,
                            //    "NMW": 0,
                            //    "TMW": 0,
                            //    "TANW": 0,
                            //    "TAW": 0,
                            //    "NP": 0,
                            //    "TP": 0,
                            //    "NB": 386,
                            //    "TB": 12984.978797379716,
                            //    "WLA": 14916.653088257723,
                            //    "TN": null,
                            //    "TC": null,
                            //    "TBC": null,
                            //    "AA": 0,
                            //    "ARA": 0,
                            //    "AD": 68.97170091111617,
                            //    "DLS": 0,
                            //    "TNMTA": 0,
                            //    "PDA": 0,
                            //    "TCD": 0,
                            //    "NPL": 14916.653088257723,
                            //    "HPL": -6.897170091111617,
                            //    "PWL": -1485.2656024124187,
                            //    "AWL": -13431.387462962008,
                            //    "TA": 12546.16639045028,
                            //    "MR": 0,
                            //    "RU": null,
                            //    "BCBA": 0,
                            //    "BCWLA": 0,
                            //    "ICT": false,
                            //    "TW": false,
                            //    "HTWT": 0,
                            //    "RP": 0,
                            //    "PKVC": null
                            //};

                            for (var i = 0; i < d.Item1.D.Items.length; i++) {
                                if (d.Item1.D.Items[i].ICT)
                                    that.repoerIsCrypto = d.Item1.D.Items[i].ICT;
                            }
                            that.slideinPLSearchfilter = false;

                        }
                    });
                if (loadGrandTotal) {
                    this.getDataApi(`/api/reports/winloss/alltotalbmem2?${path}`,
                        function (data) {
                            that.allTotalReport = data;
                        });
                }
            },
            changeNegativecolor(value) {
                if (value < 0) {
                    return {
                        color: 'rgb(229, 54, 54)',
                        display: 'block'
                    }
                }
                else if (value > 0) {
                    return {
                        color: 'rgb(48, 135, 142)',
                        display: 'block'
                    }
                }
                return { display: 'block' }
            },
            loadCurrencyOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/cur/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddCurrencyList = d.dropdownlist;
                            //========= set default convert currency to USD====
                            if (that.bool_isFirstLoad && !that.searchCurrency) {
                                for (var i = 0; i < that.ddCurrencyList.length; i++) {
                                    if (that.ddCurrencyList[i].label == 'USD') {
                                        that.searchCurrency = that.ddCurrencyList[i].id;
                                        break;
                                    }
                                }
                                that.bool_isFirstLoad = false;
                            }
                        }
                        else {
                            that.ddCurrencyList = null;
                            that.searchCurrency = null;
                        }

                        callback();
                    });
            },

            //member +
            saveMember2() {
                var has_qrcode_img = false;
                this.obj_member2.I = 0;
                this.obj_member2.IsMember = 0;
                this.obj_member2.ICI = 0;

                this.bool_memberCV2 = true;
                this.$v.obj_member2.$touch();
                if (!this.$v.obj_member2.$error) {
                    if (this.editBirthday) {
                        if (this.editBirthday.startDate) {
                            //this.obj_member2.B = this.editBirthday.startDate;
                            this.obj_member2.B = moment(this.editBirthday.startDate, "DD MMM YYYY").add(1, 'days');
                        }
                    }

                    if (this.obj_member2.BankList) {
                        for (var i = this.obj_member2.BankList.length - 1; i >= 0; i--) {
                            if (this.obj_member2.BankList[i].I <= 0) {
                                this.obj_member2.BankList[i].I = 0;
                            }
                            if (this.obj_member2.BankList[i].QRCImage) {
                                has_qrcode_img = true;
                            }
                        }
                    }
                    if (this.obj_member2.DN == null || this.obj_member2.DN == "") {
                        this.obj_member2.DN = this.obj_member2.U;
                    }

                    //if (this.obj_member2.f_SAGI != null && this.obj_member2.f_SAGI != "") {
                    //    this.obj_member2.SAGI = this.obj_member2.f_SAGI;
                    //}

                    if (this.obj_member2.ITU) {
                        this.obj_member2.ITU = 1;
                    }
                    else {
                        this.obj_member2.ITU = 0;
                    }

                    //if (this.getUserInfo.AT == 4) {
                    //    if (this.obj_member2.AS) {
                    //        this.obj_member2.AS = 2;
                    //    }
                    //    else {
                    //        this.obj_member2.AS = 1;
                    //    }

                    //    if (this.obj_member2.ARS) {
                    //        this.obj_member2.ARS = 2;
                    //    }
                    //    else {
                    //        this.obj_member2.ARS = 1;
                    //    }
                    //}
                    this.obj_member2.SAGI = this.curSAGI
                    this.obj_member2.AGI = this.curAGI;
                    this.obj_member2.AS = 2;
                    this.obj_member2.ARS = 2;

                    var that = this;
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    if (has_qrcode_img) {
                        this.postDataApiWithAttach(`/api/m/sfgge`, this.obj_member2,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                that.bool_fullScreen = false;
                                if (s) {
                                    if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 99) {
                                        that.$fire({
                                            title: that.getLanguage["MEM"]["CA"],
                                            html: that.getLanguage["MEM"]["CICI"],
                                            width: '20em',
                                            showCancelButton: true,
                                            confirmButtonText: 'Ok',
                                            cancelButtonText: 'Cancel',
                                            reverseButtons: true,
                                            customClass: {
                                                title: 'afb-alert-title text-danger',
                                                content: 'afb-alert-content',
                                                actions: 'afb-alert-action'
                                            }
                                        }).then((result) => {
                                            if (result.value == true) {

                                                that.bool_fullLoading = true;
                                                that.obj_member2['ICI'] = 1;
                                                that.postDataApiWithAttach(`/api/m/sfgge`, that.obj_member2,
                                                    function (d, s) {
                                                        that.bool_fullLoading = false;
                                                        if (s) {
                                                            that.slideinMemSummary2 = true;

                                                            //if (that.bool_isMobileDevice) {
                                                            //    that.bool_OutletAfterSave = true;
                                                            //}
                                                            //that.getMemberList();
                                                        }
                                                    });
                                            }
                                        });
                                    }
                                    else {
                                        that.bool_isAMV = false;
                                        //if (that.bool_isMobileDevice) {
                                        //    that.bool_OutletAfterSave = true;
                                        //}
                                        //that.getMemberList();
                                    }
                                }
                            });
                    }
                    else {
                        console.log(this.obj_member2)
                        this.postDataApi(`/api/m/sfgge`, this.obj_member2,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 99) {
                                        that.$fire({
                                            title: that.getLanguage["MEM"]["CA"],
                                            html: that.getLanguage["MEM"]["CICI"],
                                            width: '20em',
                                            showCancelButton: true,
                                            confirmButtonText: 'Ok',
                                            cancelButtonText: 'Cancel',
                                            reverseButtons: true,
                                            customClass: {
                                                title: 'afb-alert-title text-danger',
                                                content: 'afb-alert-content',
                                                actions: 'afb-alert-action'
                                            }
                                        }).then((result) => {
                                            if (result.value == true) {

                                                that.bool_fullLoading = true;
                                                that.obj_member2['ICI'] = 1;
                                                that.postDataApi(`/api/m/sfgge`, that.obj_member2,
                                                    function (d, s) {
                                                        that.bool_fullLoading = false;
                                                        if (s) {
                                                            that.bool_isAMV = false;

                                                            for (var i = 0; i < that.ddEditMemberCurrencyList2.length; i++) {
                                                                if (that.ddEditMemberCurrencyList2[i].id == that.obj_member2.CI) {
                                                                    that.currency = that.ddEditMemberCurrencyList2[i].label;
                                                                }
                                                            }

                                                            const url = that.getUserInfo.SARL;
                                                            const domainurl = url.split('?rc=')[0];
                                                            that.message = `${domainurl}

`+ '%0A' + `' Username : ${that.obj_member2.U}` + '%0A' +`
Password : ${that.obj_member2.UP}`
                                                            //that.obj_member2 = {};
                                                            that.slideinMemSummary2 = true;
                                                            //if (that.bool_isMobileDevice) {
                                                            //    that.bool_OutletAfterSave = true;
                                                            //}
                                                            //that.getMemberList();
                                                        }
                                                    });
                                            }
                                        });
                                    }
                                    else {
                                        that.bool_isAMV = false;

                                        for (var i = 0; i < that.ddEditMemberCurrencyList2.length; i++) {
                                            if (that.ddEditMemberCurrencyList2[i].id == that.obj_member2.CI) {
                                                that.currency = that.ddEditMemberCurrencyList2[i].label;
                                            }
                                        }

                                        const url = that.getUserInfo.SARL;
                                        const domainurl = url.split('?rc=')[0];
                                        that.message = `${domainurl}

`+ '%0A' + `' Username : ${that.obj_member2.U}` + '%0A' +`
Password : ${that.obj_member2.UP}`
                                        //that.obj_member2 = {};
                                        that.slideinMemSummary2 = true;
                                        //    if (that.bool_isMobileDevice) {
                                        //        that.bool_OutletAfterSave = true;
                                        //    }
                                        //    that.getMemberList();
                                    }
                                }
                            });
                    }

                } else {
                    //find out the unfilled and required inputm then focus it.
                    const validation = this.$v["obj_member2"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            ValidationMemberErrMsg2(value) {
                if (this.bool_memberCV2) {
                    if (this.$v.obj_member2[value].required != undefined && !this.$v.obj_member2[value].required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.utilGetErrorLanguage(value == 'AGI' ? 'GL.AGT' : ('MEM.' + value)));
                    } else if (this.$v.obj_member2[value].sameAsPassword != undefined && !this.$v.obj_member2[value].sameAsPassword) {
                        return this.getLanguage['MEM']['ERUP'];
                    } else if (this.$v.obj_member2[value].email != undefined && !this.$v.obj_member2[value].email) {
                        return this.getLanguage['MEM']['ERE'];
                    } else if (this.$v.obj_member2[value].alphaNum != undefined && !this.$v.obj_member2[value].alphaNum) {
                        return this.getLanguage['MEM']['ERAN'];
                    }
                }
            },
            loadEditMemberCurrencyOptions2({ action, callback, instanceId }) {
                var that = this;
                this.ddEditMemberCurrencyList2 = null;
                this.obj_member2.f_SAGI = this.curSAGI;

                if (this.obj_member2.f_SAGI > 0) {
                    this.getDataApi(`/api/dd/cur/${this.obj_member2.f_SAGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddEditMemberCurrencyList2 = d.dropdownlist;
                            }
                            else {
                                that.ddEditMemberCurrencyList2 = null;
                            }

                            callback();
                        });
                }
            },

            //member qrcode
            generateQRCode(value) {
                this.bool_fullLoading = true;
                var parameter = "";
                var combinedDomain = "ggearn";
                var that = this;
                //pass the domain and parameter (doesn't matter if it's empty)
                this.getDataApi(`api/ag/gendownlineqrcode/${combinedDomain}`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.recuitQRCode = d;
                        }
                    }
                );
            },
            async downloadQR() {
                const element = document.getElementById("capture-area");
                if (!element) return;

                try {
                    const canvas = await html2canvas(element, {
                        scale: 2,
                        width: 350, // Set custom width (px)
                        height: 500, // Set custom height (px)
                        useCORS: true,
                        allowTaint: false,
                    });

                    const image = canvas.toDataURL("image/png");
                    // Create a download link
                    const link = document.createElement("a");
                    link.href = image;
                    link.download = "GGEarn recuitQRCode.png"; // Ensure correct file extension
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link); // Clean up after download
                } catch (error) {
                    console.error("Error capturing element:", error);
                }
            },

            //slideinMemDeposit
            onFileSelected(event) {
                this.selectedFile = this.validateFile(event, 0.2, [".jpg", ".jpeg", ".bmp", ".gif", ".png", ".webp"]);
            },
            processTransaction() {
                // tranType: 1 = deposit, 2 = withdraw
                var that = this;
                that.bool_fullLoading = true;

                if (this.obj_OutletTran['MI'] > 0) {
                    //common value for manual deposit/withdraw transaction
                    this.obj_OutletTran['AC'] = 2;
                    this.obj_OutletTran['CCP'] = 0;
                    this.obj_OutletTran['IMA'] = 1;
                    this.obj_OutletTran['PM'] = 3;
                    this.obj_OutletTran['RS'] = 2;
                    this.obj_OutletTran['TM'] = 1;

                    if (!this.bool_isWithdraw) {  //deposit
                        this.obj_OutletTran['DSRM'] = "::[MTA][DSM]::";
                        this.obj_OutletTran['DSRT'] = "::[MTA][DST]::";
                        this.obj_OutletTran['TT'] = "1";
                        this.obj_OutletTran["RURL"] = this.selectedFile;
                    }
                    else if (this.bool_isWithdraw) {  //withdraw
                        this.obj_OutletTran['WSRT'] = "::[MTA][WST]::";
                        this.obj_OutletTran['WSRM'] = "::[MTA][WSM]::";
                        this.obj_OutletTran['IITO'] = 1;
                        this.obj_OutletTran['TT'] = "2";
                    }
                    else {
                        that.bool_fullLoading = false;
                        return;
                    }

                    this.postDataApiWithAttach(`/api/memtrans/ap`, this.obj_OutletTran,
                        function (d, s) {
                            if (s) {

                                if (that.obj_OutletTran['PI'] > 0) {
                                    that.processManualPromo();
                                } else {
                                    that.$fire({
                                        // type: 'error',
                                        //title: that.utilGetErrorLanguage("ERR.SS"),
                                        html: that.utilGetErrorLanguage("GL.AS"),
                                        width: '20em',
                                        keydownListenerCapture: true,
                                        iconHtml: '<img src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_success-17.png" loading="lazy" width="125">',
                                        customClass: {
                                            title: 'afb-alert-title text-success',
                                            content: 'afb-alert-content',
                                            actions: 'afb-alert-action'
                                        },
                                        didOpen: () => {
                                            const confirmButton = document.querySelector('.afb-alert-action button');
                                            if (confirmButton) {
                                                confirmButton.focus();
                                            }
                                        }
                                    });
                                    that.getMemberList();
                                }
                                that.slideinMemDeposit = !that.slideinMemDeposit;
                                that.slideinMemberDetail = !that.slideinMemberDetail;
                                that.obj_member.depositAmt = 0;
                                that.obj_member.withdrawAmt = 0;
                            }
                            that.bool_fullLoading = false;
                        });
                }
            },
            processManualPromo() {
                var that = this;

                if (this.obj_OutletTran['PI'] > 0) {

                    this.obj_ManualPromo.R.push({
                        "MI": this.obj_OutletTran['MI'],
                        "PI": this.obj_OutletTran['PI']
                    })

                    this.obj_ManualPromo['AGI'] = this.obj_OutletTran['AGI'];
                    this.obj_ManualPromo['CNT'] = "::[PM][PST]::";
                    this.obj_ManualPromo['CNM'] = "::[PM][PSM]::";
                }

                this.postDataApi(`/api/mpromo/mapv2`, this.obj_ManualPromo,
                    function (d, s) {
                        if (s) {
                            if (d != null && d.D != null && d.D.Items != null && d.D.Items.length > 0 && !d.D.Items[0].S) {
                                that.$fire({
                                    // type: 'error',
                                    //title: that.utilGetErrorLanguage("ERR.SS"),
                                    html: that.utilGetErrorLanguage("DEPOSIT.DSRT") + " " + that.processMessage(d.D.Items[0].R),
                                    width: '20em',
                                    keydownListenerCapture: true,
                                    iconHtml: '<img src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_success-17.png" loading="lazy" width="125">',
                                    customClass: {
                                        title: 'afb-alert-title text-success',
                                        content: 'afb-alert-content',
                                        actions: 'afb-alert-action'
                                    },
                                    didOpen: () => {
                                        const confirmButton = document.querySelector('.afb-alert-action button');
                                        if (confirmButton) {
                                            confirmButton.focus();
                                        }
                                    }
                                });
                            }
                            else {
                                that.$fire({
                                    // type: 'error',
                                    //title: that.utilGetErrorLanguage("ERR.SS"),
                                    html: that.utilGetErrorLanguage("GL.AS"),
                                    width: '20em',
                                    keydownListenerCapture: true,
                                    iconHtml: '<img src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_success-17.png" loading="lazy" width="125">',
                                    customClass: {
                                        title: 'afb-alert-title text-success',
                                        content: 'afb-alert-content',
                                        actions: 'afb-alert-action'
                                    },
                                    didOpen: () => {
                                        const confirmButton = document.querySelector('.afb-alert-action button');
                                        if (confirmButton) {
                                            confirmButton.focus();
                                        }
                                    }
                                });
                            }
                        }
                        else {

                            that.$fire({
                                // type: 'error',
                                //title: that.utilGetErrorLanguage("ERR.SS"),
                                html: that.utilGetErrorLanguage("DEPOSIT.DSRT") + " " + that.utilGetErrorLanguage("PM.PRT"),
                                width: '20em',
                                keydownListenerCapture: true,
                                iconHtml: '<img src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_success-17.png" loading="lazy" width="125">',
                                customClass: {
                                    title: 'afb-alert-title text-success',
                                    content: 'afb-alert-content',
                                    actions: 'afb-alert-action'
                                },
                                didOpen: () => {
                                    const confirmButton = document.querySelector('.afb-alert-action button');
                                    if (confirmButton) {
                                        confirmButton.focus();
                                    }
                                }
                            });
                        }
                        that.bool_fullLoading = false;
                        that.getMemberList();
                    });
            },
            processMessage(_errArr) {
                let temp = '';
                let msg = '';

                for (var i = 0; i < _errArr.length; i++) {
                    if (_errArr[i].ERRC && _errArr[i].CL && _errArr[i].CL.length > 0) {
                        var arr_args = this.splitColumnName(_errArr[i].CL);
                        var targs = [];
                        targs.push(this.utilGetErrorLanguage(_errArr[i].ERRC));
                        for (var j = 0; j < arr_args.length; j++) {
                            targs.push(arr_args[j]);
                        }

                        temp = String.format.apply(null, targs);
                    }
                    else if (_errArr[i].ERRC) {
                        temp = this.utilGetErrorLanguage(_errArr[i].ERRC);
                    }
                    else if (_errArr[i].CL && _errArr[i].CL.length > 0) {
                        if (_errArr[i].CL.length == 1)
                            temp = this.utilGetErrorLanguage(_errArr[i].CL[0]);
                        else {
                            var arr_ags = this.splitColumnName(_errArr[i].CL);
                            temp = arr_ags.join("\n\n");
                        }
                    }

                    msg += temp + "\n\n";
                }

                return msg;
            },

            //slideinMemberDetail
            getRandomUser_Pass() {
                var username = "";
                var pass = "";
                var that = this;
                this.getDataApi(`/api/m/rand/${that.obj_member.SAGAGI}`,
                    function (d, s) {
                        if (s) {
                            that.obj_member.U = d.D.r_user_name;
                            that.obj_member.UP = d.D.r_password;
                            that.obj_member.CUP = d.D.r_password;
                            that.obj_member.NUP = d.D.r_password;
                            that.str_afterSaveOutlet_URL = d.D.membersite_url;
                            that.$forceUpdate();
                        }
                    });
            },
            editMember(d) {
                this.bool_fullLoading = true;
                this.bool_memberCV = false;
                this.bool_EnableAffiliate = false;
                this.editBirthday = { startDate: null, endDate: null };
                this.ddEditMemberTypeList = null;
                if (d == 0) {
                    this.obj_member = {
                        I: 0,
                        RS: 2,
                        AGI: null,
                        f_AGI: null,
                        f_SAGI: null,
                        f_RI: null,
                        U: null,
                        UP: null,
                        CUP: null,
                        NUP: null,
                        MRI: null,
                        CI: null,
                        DN: "",
                        B: null,
                        E: null,
                        PN: null,
                        WC: null,
                        LID: null,
                        RC: null,
                        RI: null,
                        CBL: null,
                        TD: null,
                        TTO: null,
                        TB: null,
                        RTO: null,
                        HEB: false,
                        IsMember: 0,
                        ITU: false,
                        ICI: 0,
                        AI: null,
                        AN: null,
                    };

                    this.slideinEditMemDetail = !this.slideinEditMemDetail;

                    this.ddDefaultMemberList = [];
                    this.ddDefaultMarketerList = null;
                    //if (this.ddAgentList && this.ddAgentList.length > 0 && this.ddAgentList[0].children == undefined) {
                    //    var at = 0;
                    //    at = this.ddAgentList[0].id.split("-")[0];
                    //    if ((at == 3 || at == 4) && this.ddAgentList.length < 2) {
                    //        this.obj_member.f_AGI = this.ddAgentList[0];
                           
                    //        this.AgentGroupChange();
                    //    }
                    //}

                    if (this.getUserInfo.AT === 4) {
                        if (d == 0) {
                            this.obj_member.f_SAGI = this.searchSubAgent;
                            this.rtSubBrand = this.rtSubBrand == 0 ? 1 : 0;
                            this.SubAgentGroupChange();
                        }
                        else {
                            this.loadDefaultSubBrand(0, true);
                        }
                    }
                    else {
                        this.ddDefaultSubBrand = [];
                    }

                    this.bool_fullLoading = false;
                }
                else {
                    var that = this;
                    this.loadDefaultSubBrand(d.AGI);                                        
                    this.getDataApi(`/api/m/g/${d.AGI}/${d.I}`,
                        function (d, s) {
                            if (s) {
                                that.obj_member = d.D;                                
                                that.obj_member.HEB = false;
                                that.setMember();
                                that.slideinEditMemDetail = !that.slideinEditMemDetail;
                                that.slideinMemberDetail = false;
                            }
                            that.bool_fullLoading = false;
                        });
                }
            },
            setMember() {
                if (this.obj_member.AGI == 0) {
                    this.obj_member.AGI = null;
                }
                else {
                    this.obj_member.f_AGI = {
                        id: "3-" + this.obj_member.AGI
                    };
                   // this.GetBankBrandDropDown(this.obj_member.AGI, this.obj_member.CI);
                }

                if (this.obj_member.SAGI != null && this.obj_member.SAGI != 0) {
                    //this.loadDefaultSubBrand(this.obj_member.SAGI);
                    this.obj_member.f_SAGI = this.obj_member.SAGI;
                } else {
                    this.obj_member.f_SAGI = null;
                }

                this.obj_member.f_RI = null;

                if (this.obj_member.TB == null) {
                    this.obj_member.TB = 0;
                }

                if (this.obj_member.MRI == 0) {
                    this.obj_member.MRI = null;
                }

                if (this.obj_member.CI == 0) {
                    this.obj_member.CI = null;
                } else {
                    if (this.obj_member.SAGI > 0) {
                        this.searchAgi = this.obj_member.SAGI;
                    } else {
                        this.searchAgi = this.obj_member.AGI;
                    }
                    // check the affiliate setting had been activated or not
                    if (this.obj_member.CI > 0 && this.obj_member.I > 0 && this.obj_member.RI == 0) {
                        var that = this;
                       // that.GetBankBrandDropDown(that.obj_member.AGI, that.obj_member.CI);
                        that.ddDefaultMemberList = [];
                        that.getDataApi(`/api/m/checkaff/${that.obj_member.AGI}/${that.obj_member.CI}`,
                            function (d, s) {
                                if (s) {
                                    that.bool_EnableAffiliate = d;
                                }
                            });
                    }

                    this.obj_member.CIN = this.getLanguage['CUR'][this.obj_member.IC];
                }

                

                if (this.obj_member.MTI == 0) {
                    this.obj_member.MTI = null;
                }
                if (this.obj_member.AI > 0) {
                    this.ddDefaultMarketerList = [{ id: this.obj_member.AI, label: this.obj_member.AN }];

                } else {
                    this.ddDefaultMarketerList = null;
                    this.obj_member.AI = null;
                }

                if (this.obj_member.ITU == 1) {
                    this.obj_member.ITU = true;
                }
                else {
                    this.obj_member.ITU = false;
                }

                if (this.getUserInfo.AT == 4) {
                    if (this.obj_member.ARS == 2) {
                        this.obj_member.ARS = true;
                    }
                    else {
                        this.obj_member.ARS = false;
                    }

                    if (this.obj_member.AS == 2) {
                        this.obj_member.AS = true;
                    }
                    else {
                        this.obj_member.AS = false;
                    }
                }


                this.bool_EnableAffiliate = true;
                if (this.obj_member.RI == 0) {
                    this.obj_member.RI = null;
                    this.bool_haveRef = false;
                    this.ddDefaultMemberList = [];
                } else {
                    this.bool_haveRef = true;
                    this.bool_cacheOptionValue = true;
                    if (this.obj_member.SAGI > 0) {
                        this.loadDefaultMember(this.obj_member.SAGI, this.obj_member.I, this.obj_member.RI);
                    } else {
                        this.loadDefaultMember(this.obj_member.AGI, this.obj_member.I, this.obj_member.RI);
                    }

                }

                this.editBirthday = { startDate: this.obj_member.B, endDate: null };

            },
            loadDefaultMember(agi, mi = 0, ri = 0) {
                var that = this;

                this.getDataApi(`/api/dd/creferral/_/${agi}/${mi}/${ri}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultMemberList = d.dropdownlist;
                            that.rtAffiliateKey = that.rtAffiliateKey == 0 ? 1 : 0;
                        }
                        else {
                            that.ddDefaultMemberList = [];
                        }
                    });
            },
            //GetBankBrandDropDown(agi, ci) {
            //    var that = this;
            //    ci = ci ? ci : 0;

            //    this.ddEditBankBrandList = null;
            //    this.getDataApi(`/api/dd/memwithbank/${agi}/${ci}`,
            //        function (d, s) {
            //            if (s && d && d.dropdownlist) {
            //                that.ddEditBankBrandList = d.dropdownlist;
            //            }
            //            else {
            //                that.ddEditBankBrandList = null;
            //            }
            //        });
            //},
            SubAgentGroupChange(value) {
                var that = this;
                if (this.obj_member.I == 0) {
                    this.ddEditMemberRankList = null;
                    this.obj_member.MRI = null;
                    this.ddEditMemberTypeList = null;
                    this.obj_member.MTI = null;
                    this.ddEditMemberCurrencyList = null;
                    this.ddRegisterSourceList = null;
                    this.obj_member.CI = null;
                    this.ddEditBankBrandList = null;
                }

                this.obj_member.SAGI = 0;

                if (this.obj_member.f_SAGI) {
                    if (this.obj_member.I > 0 && !this.bool_haveRef) {
                        this.obj_member.RI = null;
                    }

                    var agiSelectedValue = '';
                    if (typeof this.obj_member.f_SAGI === 'string') {
                        agiSelectedValue = this.obj_member.f_SAGI;
                        var agentList = agiSelectedValue.split("-");
                        this.obj_member.SAGAGI = agentList[agentList.length - 1];
                    }
                    else {
                        agiSelectedValue = this.obj_member.f_SAGI.id;
                        var agentList = agiSelectedValue.split("-");
                        if (agentList[0] == "4") {
                            this.obj_member.SAGAGI = this.obj_member.f_SAGI.extra;
                            this.obj_member.SAGI = agentList[agentList.length - 1];
                        }
                        else {
                            this.obj_member.SAGAGI = agentList[agentList.length - 1];
                        }
                    }
                    this.searchAgi = this.obj_member.SAGAGI;
                } else if (!this.obj_member.f_SAGI && this.obj_member.I > 0 && !this.bool_haveRef) {
                    this.searchAgi = this.obj_member.AGI;
                    this.obj_member.RI = null;
                }
                if (this.obj_member.I == 0) {
                    if (this.bool_isMobileDevice) {
                        this.getRandomUser_Pass()
                    }
                }

                if (value) {
                    this.getDataApi(`/api/sag/g/${value}`,
                        function (d, s) {
                            if (s) {
                                //that.bool_EnableAffiliate = d.D.IOL == 1;

                                //Get subagent's agent
                                if (that.getUserInfo.AT === 4)
                                    that.obj_member.AGI = d.D.PGI;
                            }
                        });
                }

                const options = {
                    callback: () => {
                        if (that.ddEditMemberCurrencyList.length == 1) {
                            that.obj_member.CI = that.ddEditMemberCurrencyList[0].id;
                        }
                    }
                };
                this.loadEditMemberCurrencyOptions(options);

                if (this.obj_member.I == 0) {
                    this.obj_member.BankList = null;
                }
                //this.GetBankBrandDropDown(this.obj_member.SAGAGI, this.obj_member.CI);
            },

            //slideinSearchFilter
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;

                if (this.obj_member && this.obj_member.f_AGI && this.slideinEditMemDetail) {
                    var agentList = this.obj_member.f_AGI.id.split("-");
                    parentAGI = agentList[agentList.length - 1];
                }
                else if (this.searchAgent && !this.slideinEditMemDetail) {
                    var agentList = this.searchAgent.split("-");
                    parentAGI = agentList[agentList.length - 1];
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = 0;
                }
                else {
                    this.ddSubAgentList = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddSubAgentList = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddSubAgentList = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                                //if (that.getUserInfo.AT === 4)
                                //    that.SubAgentGroupChange(parentAGI);
                            }
                            else {
                                that.ddSubAgentList = [];
                            }
                            callback(null, that.ddSubAgentList);
                        });
                }
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${this.searchSubAgent}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },

            //slideinPLSearchfilter
            loadSubBrandOptions2({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;

                if (this.obj_member && this.obj_member.f_AGI && this.slideinEditMemDetail) {
                    var agentList = this.obj_member.f_AGI.id.split("-");
                    parentAGI = agentList[agentList.length - 1];
                }
                else if (this.searchAgent && !this.slideinEditMemDetail) {
                    var agentList = this.searchAgent.split("-");
                    parentAGI = agentList[agentList.length - 1];
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = 0;
                }
                else {
                    this.ddSubAgentList2 = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddSubAgentList2 = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddSubAgentList2 = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                                //if (that.getUserInfo.AT === 4)
                                //    that.SubAgentGroupChange(parentAGI);
                            }
                            else {
                                that.ddSubAgentList2 = [];
                            }
                            callback(null, that.ddSubAgentList2);
                        });
                }
            },
            loadMemberOptions2({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList2 = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${this.searchSubAgent2}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList2 = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.ddMemberList2 = [];
                            }

                            callback(null, that.ddMemberList2);
                        });
                }
            },

            //slideinMemBlacklist
            blacklistMember(d) {
                this.bool_blacklistCV = false;
                this.dd_rejectreason = constRejectReasonBL;
                this.obj_blacklist = {
                    RM: null,
                    _d: d
                };
                this.obj_Reject = {
                    "reason": null,
                    "reason2": ""
                },
                this.slideinMemberDetail = false;
                this.slideinMemBlacklist = true;
            },
            unBlacklistMember(d) {
                this.$fire({
                    title: this.getLanguage["MEM"]["CUBLK"],
                    width: '20em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    iconHtml: '<img src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/question.svg" loading="lazy">',
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: d.I,
                            uts: d.UTS,
                            agi: d.AGI,
                            CI: d.CI,
                            U: d.U
                        };

                        this.postDataApi(`/api/m/ubm`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.slideinMemberDetail = false;
                                    that.getMemberList();
                                    that.$fire({
                                        // type: 'error',
                                        //title: that.utilGetErrorLanguage("ERR.SS"),
                                        html: that.utilGetErrorLanguage("GL.AS"),
                                        width: '20em',
                                        keydownListenerCapture: true,
                                        iconHtml: '<img src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_success-17.png" loading="lazy" width="125">',
                                        customClass: {
                                            title: 'afb-alert-title text-success',
                                            content: 'afb-alert-content',
                                            actions: 'afb-alert-action'
                                        },
                                        didOpen: () => {
                                            const confirmButton = document.querySelector('.afb-alert-action button');
                                            if (confirmButton) {
                                                confirmButton.focus();
                                            }
                                        }
                                    });
                                }
                            });
                    }
                });
            },
            saveBlacklist() {
                this.bool_blacklistCV = true;

                var rejectreason = this.obj_Reject.reason == 999 ? this.obj_Reject.reason2 : this.obj_Reject.reason;

                if (rejectreason != "" && rejectreason != null) {
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    var that = this;
                    var dt = [{
                        I: this.obj_blacklist._d.I,
                        UTS: this.obj_blacklist._d.UTS,
                        BR: rejectreason,
                        AGI: this.obj_blacklist._d.AGI,
                        ICI: 0,
                        CI: this.obj_blacklist._d.CI,
                        U: this.obj_blacklist._d.U
                    }];

                    //this.postDataApi(`/api/m/bm`, dt,
                    //    function (d, s)
                    //    {
                    //        that.bool_fullLoading = false;

                    //        if (s)
                    //        {
                    //            that.slideinMemBlacklist = false;
                    //            that.getMemberList();
                    //        }
                    //    });
                    this.postDataApi(`/api/m/bm`, dt,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 99) {
                                    that.$fire({
                                        title: that.getLanguage["MEM"]["CA"],
                                        html: that.getLanguage["MEM"]["CICI"],
                                        width: '20em',
                                        showCancelButton: true,
                                        confirmButtonText: 'Ok',
                                        cancelButtonText: 'Cancel',
                                        reverseButtons: true,
                                        customClass: {
                                            title: 'afb-alert-title text-danger',
                                            content: 'afb-alert-content',
                                            actions: 'afb-alert-action'
                                        }
                                    }).then((result) => {
                                        if (result.value == true) {
                                            that.bool_fullLoading = true;
                                            dt[0]['ICI'] = 1;
                                            that.postDataApi(`/api/m/bm`, dt,
                                                function (d, s) {
                                                    that.bool_fullLoading = false;
                                                    if (s) {
                                                        that.slideinMemBlacklist = false;
                                                        that.slideinMemberDetail = false;
                                                        that.getMemberList();
                                                    }
                                                });
                                        }
                                    });
                                }
                                else {
                                    that.slideinMemBlacklist = false;
                                    that.slideinMemberDetail = false;
                                    that.$fire({
                                        // type: 'error',
                                        //title: that.utilGetErrorLanguage("ERR.SS"),
                                        html: that.utilGetErrorLanguage("GL.AS"),
                                        width: '20em',
                                        keydownListenerCapture: true,
                                        iconHtml: '<img src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_success-17.png" loading="lazy" width="125">',
                                        customClass: {
                                            title: 'afb-alert-title text-success',
                                            content: 'afb-alert-content',
                                            actions: 'afb-alert-action'
                                        },
                                        didOpen: () => {
                                            const confirmButton = document.querySelector('.afb-alert-action button');
                                            if (confirmButton) {
                                                confirmButton.focus();
                                            }
                                        }
                                    });

                                    that.getMemberList();
                                }
                            }
                        });
                }
            },
            ValidationBlackListErrMsg(value) {
                if (this.bool_blacklistCV) {
                    var validateObj = this.$v.obj_Reject[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.getLanguage["ERR"]["1001"], this.getLanguage["MEM"]["RR"]);
                    }
                }
            },

            //slideinMemFreeze
            freezeMember(d) {
                this.bool_freezeCV = false;
                this.dd_rejectreasonF = constRejectReasonF;
                this.obj_freeze = {
                    RM: null,
                    _d: d
                };
                this.obj_RejectF = {
                    "reason": null,
                    "reason2": ""
                },
                this.slideinMemberDetail = false;
                this.slideinMemFreeze = true;
            },
            unFreezeMember(d) {
                this.$fire({
                    title: this.getLanguage["MEM"]["CUF"],
                    width: '20em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    iconHtml: '<img src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/question.svg" loading="lazy">',
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: d.I,
                            uts: d.UTS,
                            agi: d.AGI
                        };

                        this.postDataApi(`/api/m/ufm`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.slideinMemberDetail = false;
                                    that.getMemberList();
                                    that.$fire({
                                        // type: 'error',
                                        //title: that.utilGetErrorLanguage("ERR.SS"),
                                        html: that.utilGetErrorLanguage("GL.AS"),
                                        width: '20em',
                                        keydownListenerCapture: true,
                                        iconHtml: '<img src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_success-17.png" loading="lazy" width="125">',
                                        customClass: {
                                            title: 'afb-alert-title text-success',
                                            content: 'afb-alert-content',
                                            actions: 'afb-alert-action'
                                        },
                                        didOpen: () => {
                                            const confirmButton = document.querySelector('.afb-alert-action button');
                                            if (confirmButton) {
                                                confirmButton.focus();
                                            }
                                        }
                                    });
                                }
                            });
                    }
                });
            },
            saveFreeze() {
                this.bool_freezeCV = true;

                var rejectreason = this.obj_RejectF.reason == 999 ? this.obj_RejectF.reason2 : this.obj_RejectF.reason;

                if (rejectreason != "" && rejectreason != null) {
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    var that = this;
                    var dt = [{
                        I: this.obj_freeze._d.I,
                        UTS: this.obj_freeze._d.UTS,
                        FR: rejectreason,
                        AGI: this.obj_freeze._d.AGI,
                        ICI: 0
                    }];

                    this.postDataApi(`/api/m/fm`, dt,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 99) {
                                    that.$fire({
                                        title: that.getLanguage["MEM"]["CA"],
                                        html: that.getLanguage["MEM"]["CICI"],
                                        width: '20em',
                                        showCancelButton: true,
                                        confirmButtonText: 'Ok',
                                        cancelButtonText: 'Cancel',
                                        reverseButtons: true,
                                        customClass: {
                                            title: 'afb-alert-title text-danger',
                                            content: 'afb-alert-content',
                                            actions: 'afb-alert-action'
                                        }
                                    }).then((result) => {
                                        if (result.value == true) {
                                            that.bool_fullLoading = true;
                                            dt[0]['ICI'] = 1;
                                            that.postDataApi(`/api/m/fm`, dt,
                                                function (d, s) {
                                                    that.bool_fullLoading = false;
                                                    if (s) {
                                                        that.slideinMemFreeze = false;
                                                        that.slideinMemberDetail = false;
                                                        that.getMemberList();
                                                    }
                                                });
                                        }
                                    });
                                }
                                else {
                                    that.slideinMemFreeze = false;
                                    that.slideinMemberDetail = false;
                                    that.$fire({
                                        // type: 'error',
                                        //title: that.utilGetErrorLanguage("ERR.SS"),
                                        html: that.utilGetErrorLanguage("GL.AS"),
                                        width: '20em',
                                        keydownListenerCapture: true,
                                        //iconHtml: '<img src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_success-17.png" loading="lazy" width="125">',
                                        iconHtml: '<img src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_success-17.png" loading="lazy" width="125">',
                                        customClass: {
                                            title: 'afb-alert-title text-success',
                                            content: 'afb-alert-content',
                                            actions: 'afb-alert-action'
                                        },
                                        didOpen: () => {
                                            const confirmButton = document.querySelector('.afb-alert-action button');
                                            if (confirmButton) {
                                                confirmButton.focus();
                                            }
                                        }
                                    });

                                    that.getMemberList();
                                }
                            }
                        });
                }
            },
            ValidationFreezeErrMsg(value) {
                if (this.bool_freezeCV) {
                    var validateObj = this.$v.obj_RejectF[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.getLanguage["ERR"]["1001"], this.getLanguage["MEM"]["FRR"]);
                    }
                }
            },

            //slideinMemSummary
            copyMemberLink(ElementId) {
                const url = this.getUserInfo.SARL;
                const domainurl = url.split('?rc=')[0];
                console.log(domainurl)
                if (this.slideinMemSummary) {
                    var username = this.obj_member.U;
                    var password = this.obj_member.UP;
                } else if (this.slideinMemSummary2) {
                    var username = this.obj_member2.U;
                    var password = this.obj_member2.UP;
                }

                var message = `${domainurl}

Username : ${username}
Password : ${password}`;

                navigator.clipboard.writeText(message);

                //var input = document.getElementById(ElementId);
                //input.select();
                //document.execCommand("copy");
                //var tooltip = document.querySelector(".tooltip-modal");
                //tooltip.classList.add("show");
                //setTimeout(function () {
                //    tooltip.classList.remove("show");
                //}, 1000);


                this.$fire({
                    // type: 'error',
                    title: this.utilGetErrorLanguage("GL.COPY"),
                    html: this.utilGetErrorLanguage("GL.COPYM"),
                    width: '20em',
                    keydownListenerCapture: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    },
                    didOpen: () => {
                        const confirmButton = document.querySelector('.afb-alert-action button');
                        if (confirmButton) {
                            confirmButton.focus();
                        }
                    }
                });
            },

            //slideinEditMemDetail
            saveMember() {
                var has_qrcode_img = false;
                this.obj_member.IsMember = 0;
                this.obj_member.ICI = 0;

                this.bool_memberCV = true;
                this.$v.obj_member.$touch();
                if (!this.$v.obj_member.$error) {
                    if (this.editBirthday) {
                        if (this.editBirthday.startDate) {
                            //this.obj_member.B = this.editBirthday.startDate;
                            this.obj_member.B = moment(this.editBirthday.startDate, "DD MMM YYYY").add(1, 'days');
                        }
                    }

                    if (this.obj_member.BankList) {
                        for (var i = this.obj_member.BankList.length - 1; i >= 0; i--) {
                            if (this.obj_member.BankList[i].I <= 0) {
                                this.obj_member.BankList[i].I = 0;
                            }
                            if (this.obj_member.BankList[i].QRCImage) {
                                has_qrcode_img = true;
                            }
                        }
                    }
                    if (this.obj_member.DN == null || this.obj_member.DN == "") {
                        this.obj_member.DN = this.obj_member.U;
                    }

                    if (this.obj_member.f_SAGI != null && this.obj_member.f_SAGI != "") {
                        this.obj_member.SAGI = this.obj_member.f_SAGI;
                    }

                    if (this.obj_member.ITU) {
                        this.obj_member.ITU = 1;
                    }
                    else {
                        this.obj_member.ITU = 0;
                    }

                    if (this.getUserInfo.AT == 4) {
                        if (this.obj_member.AS) {
                            this.obj_member.AS = 2;
                        }
                        else {
                            this.obj_member.AS = 1;
                        }

                        if (this.obj_member.ARS) {
                            this.obj_member.ARS = 2;
                        }
                        else {
                            this.obj_member.ARS = 1;
                        }
                    }

                    var that = this;
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    if (has_qrcode_img) {
                        this.postDataApiWithAttach(`/api/m/sfgge`, this.obj_member,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                that.bool_fullScreen = false;
                                if (s) {
                                    if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 99) {
                                        that.$fire({
                                            title: that.getLanguage["MEM"]["CA"],
                                            html: that.getLanguage["MEM"]["CICI"],
                                            width: '20em',
                                            showCancelButton: true,
                                            confirmButtonText: 'Ok',
                                            cancelButtonText: 'Cancel',
                                            reverseButtons: true,
                                            customClass: {
                                                title: 'afb-alert-title text-danger',
                                                content: 'afb-alert-content',
                                                actions: 'afb-alert-action'
                                            }
                                        }).then((result) => {
                                            if (result.value == true) {

                                                that.bool_fullLoading = true;
                                                that.obj_member['ICI'] = 1;
                                                that.postDataApiWithAttach(`/api/m/sfgge`, that.obj_member,
                                                    function (d, s) {
                                                        that.bool_fullLoading = false;
                                                        if (s) {
                                                            that.slideinEditMemDetail = false;
                                                            if (that.bool_isMobileDevice) {
                                                                that.bool_OutletAfterSave = true;
                                                            }

                                                            that.getMemberList();
                                                        }
                                                    });
                                            }
                                        });
                                    }
                                    else {
                                        that.slideinEditMemDetail = false;
                                        //if (that.bool_isMobileDevice){
                                        //    that.bool_OutletAfterSave= true;
                                        //}

                                        that.slideinMemberDetail = false;
                                        that.$fire({
                                            // type: 'error',
                                            //title: that.utilGetErrorLanguage("ERR.SS"),
                                            html: that.utilGetErrorLanguage("GL.AS"),
                                            width: '20em',
                                            keydownListenerCapture: true,
                                            iconHtml: '<img src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_success-17.png" loading="lazy" width="125">',
                                            customClass: {
                                                title: 'afb-alert-title text-success',
                                                content: 'afb-alert-content',
                                                actions: 'afb-alert-action'
                                            },
                                            didOpen: () => {
                                                const confirmButton = document.querySelector('.afb-alert-action button');
                                                if (confirmButton) {
                                                    confirmButton.focus();
                                                }
                                            }
                                        });


                                        that.getMemberList();
                                    }
                                }
                            });
                    }
                    else {
                        this.postDataApi(`/api/m/sfgge`, this.obj_member,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 99) {
                                        that.$fire({
                                            title: that.getLanguage["MEM"]["CA"],
                                            html: that.getLanguage["MEM"]["CICI"],
                                            width: '20em',
                                            showCancelButton: true,
                                            confirmButtonText: 'Ok',
                                            cancelButtonText: 'Cancel',
                                            reverseButtons: true,
                                            customClass: {
                                                title: 'afb-alert-title text-danger',
                                                content: 'afb-alert-content',
                                                actions: 'afb-alert-action'
                                            }
                                        }).then((result) => {
                                            if (result.value == true) {

                                                that.bool_fullLoading = true;
                                                that.obj_member['ICI'] = 1;
                                                that.postDataApi(`/api/m/sfgge`, that.obj_member,
                                                    function (d, s) {
                                                        that.bool_fullLoading = false;
                                                        if (s) {
                                                            that.slideinEditMemDetail = false;
                                                            if (that.bool_isMobileDevice) {
                                                                that.bool_OutletAfterSave = true;
                                                            }

                                                            const url = that.getUserInfo.SARL;
                                                            const domainurl = url.split('?rc=')[0];
                                                            that.message = `${domainurl}

Username : ${that.obj_member.U}
Password : ${that.obj_member.UP}`
                                                            that.slideinMemSummary = true;

                                                            that.getMemberList();
                                                        }
                                                    });
                                            }
                                        });
                                    }
                                    else {
                                        that.slideinEditMemDetail = false;
                                        if (that.bool_isMobileDevice) {
                                            that.bool_OutletAfterSave = true;
                                        }

                                        const url = that.getUserInfo.SARL;
                                        const domainurl = url.split('?rc=')[0];
                                        that.message = `${domainurl}

Username : ${that.obj_member.U}
Password : ${that.obj_member.UP}`
                                        that.slideinMemSummary = true;

                                        that.getMemberList();
                                    }
                                }
                            });
                    }
                } else {
                    //find out the unfilled and required inputm then focus it.
                    const validation = this.$v["obj_member"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            //loadEditMemberTypeOptions({ action, callback, instanceId }) {
            //    var that = this;
            //    if (!this.obj_member.AGI) {
            //        callback(this.getLanguage['MEM']['PSAA']);
            //    }
            //    else {
            //        this.getDataApi(`/api/dd/mType/${this.obj_member.AGI}`,
            //            function (d, s) {
            //                if (s && d && d.dropdownlist) {
            //                    that.ddEditMemberTypeList = d.dropdownlist;
            //                }
            //                else {
            //                    that.ddEditMemberTypeList = null;
            //                }

            //                callback();
            //            });
            //    }
            //},
            //MemberCurrencyChange(value) {
            //    var agi = this.obj_member.AGI;
            //    var ci = this.obj_member.CI;
            //    var mi = this.obj_member.I;
            //    var that = this;
            //    if (ci > 0 && mi == 0) {
            //        //this.GetBankBrandDropDown(agi, ci);
            //        this.ddDefaultMemberList = [];
            //        if (agi > 0) {
            //            if (this.obj_member.f_SAGI > 0) {
            //                this.searchAgi = this.obj_member.f_SAGI;
            //                this.obj_member.RI = null;
            //            } else {
            //                this.searchAgi = agi;
            //                this.obj_member.RI = null;
            //            }
            //            this.getDataApi(`/api/m/checkaff/${agi}/${ci}`,
            //                function (d, s) {
            //                    if (s) {
            //                        that.bool_EnableAffiliate = d;
            //                    }
            //                });
            //        }
            //    } else {
            //        that.bool_EnableAffiliate = false;
            //    }
            //},
            ValidationMemberErrMsg(value) {
                if (this.bool_memberCV) {
                    if (this.$v.obj_member[value].required != undefined && !this.$v.obj_member[value].required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.utilGetErrorLanguage(value == 'AGI' ? 'GL.AGT' : ('MEM.' + value)));
                    } else if (this.$v.obj_member[value].sameAsPassword != undefined && !this.$v.obj_member[value].sameAsPassword) {
                        return this.getLanguage['MEM']['ERUP'];
                    } else if (this.$v.obj_member[value].email != undefined && !this.$v.obj_member[value].email) {
                        return this.getLanguage['MEM']['ERE'];
                    } else if (this.$v.obj_member[value].alphaNum != undefined && !this.$v.obj_member[value].alphaNum) {
                        return this.getLanguage['MEM']['ERAN'];
                    }
                }
            },

            //slideinMemberDetail
            transactionShortcut(memData, tranType) {
                // tranType: 1 = deposit, 2 = withdraw
                var actionLang;
                var tranAmt;
                this.obj_OutletTran = [];
                if (memData.I > 0 && ((memData.depositAmt > 0 && tranType == '1') || (memData.withdrawAmt > 0 && tranType == '2'))) {
                    //this.getPromotionDDList(memData.AGI, memData.I, memData.CI, memData.depositAmt, memData.IOL);

                    //Populate data
                    this.obj_OutletTran['AGI'] = memData.AGI;
                    this.obj_OutletTran['MI'] = memData.I;

                    if (tranType == '1') {  //deposit
                        actionLang = this.getLanguage["TD"]["TT1"];
                        tranAmt = this.formatNumber(memData.depositAmt, 2, memData.CS);
                        this.obj_OutletTran['TA'] = memData.depositAmt;
                        this.bool_isWithdraw = false;
                    }
                    else if (tranType == '2') {  //withdraw
                        actionLang = this.getLanguage["TD"]["TT2"];
                        tranAmt = this.formatNumber(memData.withdrawAmt, 2, memData.CS);
                        this.obj_OutletTran['TA'] = memData.withdrawAmt;
                        this.bool_isWithdraw = true;
                    }

                    this.strTnxConfirm = actionLang + " " + tranAmt + " " + this.getLanguage["PM"]["T"]+ " " + memData.U;
                    this.slideinMemberDetail = false;
                    this.slideinMemDeposit = !this.slideinMemDeposit;
                }
            },
            //getPromotionDDList(agi, memberId, currencyId, depositAmt, isOutlet) {
            //    var that = this;
            //    this.getDataApi(`/api/dd/dptpromo/` + agi + `/` + memberId,
            //        function (d, s) {
            //            if (s && d && d.dropdownlist) {
            //                that.dd_promotion = d.dropdownlist;
            //                that.rtPromoKey = that.rtPromoKey == 0 ? 1 : 0;
            //            }
            //            else {
            //                that.dd_promotion = [];
            //            }
            //        });
            //    //this.getDataApi(`/api/dd/gapromo/${agi}/${memberId}/${currencyId}/${depositAmt}/${isOutlet}`,
            //    //    function (d, s) {
            //    //        if (s && d && d.dropdownlist) {
            //    //            that.dd_promotion = d.dropdownlist;
            //    //            that.rtPromoKey = that.rtPromoKey == 0 ? 1 : 0;
            //    //        }
            //    //        else {
            //    //            that.dd_promotion = [];
            //    //        }
            //    //    });
            //},
            manualTriggerDLS(memData) {

                if (memData.I <= 0)
                    return;

                this.$fire({
                    title: this.getLanguage["MTA"]["CADLS"],
                    html: this.getLanguage["AFF"]["ACT"] + " > " + memData.U,
                    width: '20em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            I: memData.I,
                            SAGI: memData.SAGI,
                            IOL: memData.IOL
                        };

                        this.postDataApi(`/api/sag/smdls`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.$fire({
                                        // type: 'error',
                                        //title: that.utilGetErrorLanguage("ERR.SS"),
                                        html: that.utilGetErrorLanguage("GL.AS"),
                                        width: '20em',
                                        keydownListenerCapture: true,
                                        iconHtml: '<img src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_success-17.png" loading="lazy" width="125">',
                                        customClass: {
                                            title: 'afb-alert-title text-success',
                                            content: 'afb-alert-content',
                                            actions: 'afb-alert-action'
                                        },
                                        didOpen: () => {
                                            const confirmButton = document.querySelector('.afb-alert-action button');
                                            if (confirmButton) {
                                                confirmButton.focus();
                                            }
                                        }
                                    });



                                    that.getMemberList();
                                }
                            });
                    }
                });
            },

            //slideinMemSummary & slideinMemSummary2
            handleTouchStart(event) {
                this.startX = event.touches[0].clientX;
                this.startTime = Date.now(); // Record the start time
                this.isSwiping = false; // Reset swiping status
            },
            handleTouchMove(event) {
                this.endX = event.touches[0].clientX;

                // Determine if the user is swiping based on distance
                const distanceX = this.endX - this.startX;
                if (Math.abs(distanceX) > this.threshold) {
                    this.isSwiping = true; // Set swiping status to true if the swipe distance exceeds the threshold
                }
            },
            handleTouchEnd() {
                const distanceX = this.endX - this.startX;
                const elapsedTime = Date.now() - this.startTime;

                // Check if the swipe is valid
                if (this.isSwiping && elapsedTime < this.timeThreshold) {
                    // Only execute swipe actions if it's a valid swipe
                    if (distanceX > 0) {
                        this.nextSlide();
                    } else {
                        this.prevSlide();
                    }
                } else if (!this.isSwiping) {
                    // Treat it as a click if not swiping
                }

            },
            nextSlide() {
                this.currentSlide =
                    (this.currentSlide + 1) % 2;
            },
            prevSlide() {
                this.currentSlide =
                    (this.currentSlide - 1 + 2) %
                    2;
            },

            copyDomainLink() {
                navigator.clipboard.writeText(this.registerDomainUrl);

                this.$fire({
                    // type: 'error',
                    title: this.utilGetErrorLanguage("GL.COPY"),
                    html: this.utilGetErrorLanguage("GL.COPYM"),
                    width: '20em',
                    keydownListenerCapture: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    },
                    didOpen: () => {
                        const confirmButton = document.querySelector('.afb-alert-action button');
                        if (confirmButton) {
                            confirmButton.focus();
                        }
                    }
                });
            },
        },
        validations: {
            obj_member: {
                AGI: { required },
                U: { required, alphaNum },
                UP: {
                    required: requiredIf(function (vm) {
                        return vm.I == 0;
                    }),
                },
                CUP: {
                    required: requiredIf(function (vm) {
                        return vm.I == 0;
                    }),
                    sameAsPassword: sameAs(function (vm) { return vm.I == 0 || (vm.UP != '' && vm.UP != null) ? vm.UP : vm.CUP; })
                },
                NUP: {
                    required: requiredIf(function (vm) {
                        return vm.I == 0 && this.isOUTMOB;
                    }),
                },
                // MRI: { required },
                CI: { required },
                // DN: { required },
                // PN: { required },
                // E: { email },
            },
            obj_member2: {
                //AGI: { required },
                U: { required, alphaNum },
                UP: {
                    required: requiredIf(function (vm) {
                        return vm.I == 0;
                    }),
                    alphaNum
                },
                CUP: {
                    required: requiredIf(function (vm) {
                        return vm.I == 0;
                    }),
                    sameAsPassword: sameAs(function (vm) { return vm.I == 0 || (vm.UP != '' && vm.UP != null) ? vm.UP : vm.CUP; }),
                    alphaNum
                },
                //NUP: {
                //    required: requiredIf(function (vm) {
                //        return vm.I == 0 && this.isOUTMOB;
                //    }),
                //},
                // MRI: { required },
                CI: { required },
                // DN: { required },
                // PN: { required },
                E: { email },
            },
            obj_Reject: {
                reason2: {
                    required: requiredIf(function (vm) {
                        return !vm.reason || vm.reason == 999;
                    }),
                }
            },
            obj_RejectF: {
                reason2: {
                    required: requiredIf(function (vm) {
                        return !vm.reason || vm.reason == 999;
                    }),
                }
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage', 'getLangCode']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess', 'getUserMemberSC']),
            ...mapGetters('CurrencyInfo', ['getThousandCurrency']),
        },
        watch: {
            '$route.query': {
                handler(newQuery, oldQuery) {
                    this.dependUrlShowItem();
                },
                immediate: true // Trigger watcher immediately when the component is created
            }
        },
        created() {
            this.$parent.showSubMenu = 'M';
            this.$parent.showActiveMenu = 'M.ML';

            this.ML_A = this.checkModuleAccess('ML', 'M', constAccessType.add);
            this.ML_E = this.checkModuleAccess('ML', 'M', constAccessType.edit);
            this.ML_D = this.checkModuleAccess('ML', 'M', constAccessType.delete);
            this.MBA_A = this.checkModuleAccess('MBA', 'M', constAccessType.add);

            if (this.getUserInfo.AT == 4) {
                this.curSAGI = this.getUserInfo.AGI;
                //this.getAgentGroup();
                this.loadDefaultSubBrand(0, true);
            }

            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AAGI;
            this.bool_isMobileDevice = this.getUserInfo.IMD && this.getUserInfo.AT == 4;

            let hostname = window.location.hostname;
            var url = "https://" + hostname + "/App/MemberRegister/?pc=" + this.getUserInfo.PC + "&agi=" + this.getUserInfo.AGI;
            this.registerDomainUrl = url;
        }
    }
</script>

<style scoped>
    .breadcrumb-item + .font-xl.breadcrumb-item::before {
        color: rgb(140, 195, 38);
        content: '>>';
        padding: 0px 10px;
    }

    .c-sidebar-nav-lin {
        white-space: normal;
    }

    .ErrMsg {
        min-height: auto !important;
    }

    .sliding-item.amt .sliding-item-desc .input-group > .form-control {
        text-align: right;
    }

    .anim-box {
        position: relative;
        width: 220px;
        height: 220px;
        padding: 20px 20px;
        transition: transform .6s ease-out;
        margin: 25px auto;
    }

    /* adds the 4 corners */
    .anim-box:before, .anim-box:after, .anim-box > :first-child:before, .anim-box > :first-child:after {
        position: absolute;
        width: 10%;
        height: 15%;
        border-color: white;
        border-style: solid;
        content: ' ';
    }

    /* top left corner */
    .anim-box:before {
        top: 0;
        left: 0;
        border-width: 2px 0 0 2px;
        border-top-left-radius: 0.25rem;
        animation: scaleAnimation 2s ease-in-out infinite;
    }

    /* top right corner */
    .anim-box:after {
        top: 0;
        right: 0;
        border-width: 2px 2px 0 0;
        border-top-right-radius: 0.25rem;
        animation: scaleAnimation 2s ease-in-out infinite;
    }

    /* bottom right corner */
    .anim-box > :first-child:before {
        bottom: 0;
        right: 0;
        border-width: 0 2px 2px 0;
        border-bottom-right-radius: 0.25rem;
        animation: scaleAnimation 2s ease-in-out infinite;
    }

    /* bottom left corner */
    .anim-box > :first-child:after {
        bottom: 0;
        left: 0;
        border-width: 0 0 2px 2px;
        border-bottom-left-radius: 0.25rem;
        animation: scaleAnimation 2s ease-in-out infinite;
    }

    @keyframes scaleAnimation {
        0% {
            transform: scale(1);
        }

        50% {
            transform: scale(1.5);
        }

        100% {
            transform: scale(1);
        }
    }

    .qrcode {
        background: #fff;
        border-radius: .25rem;
    }
    .qrcode-logo {
        position: absolute;
        left: 0px;
        right: 0px;
        width: 40px;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
        padding: 5px;
        border-radius: 5px;
    }
    .qrcodecard {
        background: url('../../assets/images/qrbg.png');
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 10px;
        /*padding: 25px;*/
        height: 500px;
        width: 350px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        z-index: -1;
        top: -999px;
    }

    .qrcodecard h2 {
        text-align: center;
        color: rgb(0 0 0);
        font-weight: bold;
        font-size: 24px;
        line-height: 24px;
        margin-bottom: 25px;
    }
</style>



// WEBPACK FOOTER //
// src/componentsGGEarn/SideMenu/GGearnMember.vue